(function(){
var helpers = {
  hasAddonRestaurants: function hasAddonRestaurants(model) {
    return model.Results.AddonsRestaurant &&
      model.Results.AddonsRestaurant.Total;
  },
  displayToMiles: function (miles, unit) {
    var distance = Number(miles);

    if (unit === 'km') {
      distance = miles * 0.621371;
    }

    return Number(distance.toFixed(1));
  },
  chunk: function (array, size) {
    var length = array.length;

    if (!length || size < 1) {
      return [];
    }

    var index = 0;
    var resIndex = 0;
    var result = Array(Math.ceil(length / size));

    while (index < length) {
      result[resIndex++] = array.slice(index, index + size);
      index += size;
    }
    return result;
  },
  milesToDisplay: function (miles, unit) {
    var distance = Number(miles);

    if (unit === 'km') {
      distance = miles * 1.60934;
    }

    return Number(distance.toFixed(1));
  },
  getRelatedSearchLabels: function (searches) {
    function joinSemanticList(list, maxLength) {
      if (list.length === 1) {
        return list[0];
      }

      var shortenedList =
        list.length <= maxLength ?
          list :
          list.slice(0, maxLength);

      var exceptLast = shortenedList.slice(0, shortenedList.length - 1);
      var last = shortenedList[shortenedList.length - 1];

      return exceptLast.join(', ') + ' and ' + last;
    }

    return searches && searches.length ? searches.map(function(searchPair){
      var search = searchPair[1];
      var link = search.link || '#';
      var suggestion = '';
      var MAX_CUISINES = 3;
      var MAX_LOCATIONS = 3;

      if (search) {
        var label = search.label;

        var cuisine = label.cuisinePhrase && label.cuisinePhrase.length ?
          joinSemanticList(label.cuisinePhrase, MAX_CUISINES) + ' in ' : '';

        var location = label.nearestLocationName && label.nearestLocationName.length ?
          joinSemanticList(label.nearestLocationName, MAX_LOCATIONS) : 'a nearby restaurant';

        suggestion = cuisine + location;

        link = '/s/?' + link;
        return [suggestion, link];
      }
    }) : [];
  },
  moment: function hooks() {
    return hookCallback.apply(null, arguments);
}
};
function toPath(value) {
  if (_(value).isArray()) {
    return value;
  }
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
  var reEscapeChar = /\\(\\)?/g;
  var result = [];
  value = !value ? '' : value + '';
  value.replace(rePropName, function(match, number, quote, string) {
    result.push(
      quote ? string.replace(reEscapeChar, '$1') : number || match
    );
  });
  return result;
};
function get(object, path) {
  path = toPath(path);
  var pathKey = path + '';

  if (!object) { return; }
  if (pathKey !== undefined && pathKey in object) {
    path = [pathKey];
  }
  var index = 0;
  var length = path.length;

  while (object && index < length) {
    object = object[path[index++]];
  }

  return index && index === length ? object : undefined;
};
function partial(path, options) {
  var locals;

  // parse options
  if (options) {
    // collection
    if (options.collection) {
      delete options.collection;
    } else if ('length' in options) {
      options = {};
    }

    // locals
    if (options.locals) {
      locals = options.locals;
      delete options.locals;
    }
  } else {
    options = {};
  }

  // merge locals into options
  if (locals) {
    options.__proto__ = locals;
  }

  // merge app locals into options
  for (var k in this) {
    if (this.hasOwnProperty(k)) {
      options[k] = options[k] || this[k];
    }
  }

  var translatePathRegex = /\//g;
  var objectPath = path.replace(translatePathRegex, '.');
  var arrayPath = toPath(objectPath);
  var template = get(window.Spark, arrayPath);

  // Try to load the template file
  if (template) {
    return template.RenderView(options);
  }

  template = get(window.Spark, ['Shared'].concat(arrayPath));

  // If that doesn't work, prefix "Shared" and try again
  if (template) {
    return template.RenderView(options);
  }

  var namespacePath = options.namespace.replace(translatePathRegex, '.');
  var namespaceArray = toPath(namespacePath);

  namespaceArray.shift(); // Remove Spark
  namespaceArray.pop();   // Remove template from path, to get folder

  template = get(window.Spark, namespaceArray.concat(arrayPath));

  // If we still don't have a template, chop up the path a bit
  if (template) {
    return template.RenderView(options);
  }

  // Still no template? Fail silently.
  return '<!-- ' + path + '-->';
};
function block(name, html) {
// bound to the blocks object in renderFile
  var blk = this[name];
  if (!blk) {
// always create, so if we request a
// non-existent block we'll get a new one
    blk = this[name] = new Block();
  }
  if (html) {
    blk.append(html);
  }
  return blk;
};
function layout(view){
  this.locals._layoutFile = view;
};
window.Spark = {"Shared":{"Common":{"_MapFooter":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var model = locals.Model ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push('<div class="footer-container-short"><div class="footer-base"> <span class="footer-copyright">', (1,  (String.Format(Resources.Shared.Redesign.Strings.CopyrightFormat, new Date().getFullYear())) ), '</span> <a class="footer-base-link" href="/info/privacypolicy.aspx">', escape((1,  (Resources.Shared.Redesign.Strings.MapFooterLink_Privacy) )), '</a> <a class="footer-base-link" href="/info/agreement.aspx">', escape((1,  (Resources.Shared.Redesign.Strings.MapFooterLink_Terms) )), '</a></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Common._MapFooter'}
,"_SeoFooter":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var System = locals.System ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var OTRequestId = Model.OTRequestId || 'N/A' ; buf.push(' ', (1,  Html.RenderAction("Footer", "Srs", {
  domainCulture: Model.DomainCulture,
  metro: Model.Display.Metro
}) ), '<div class="global-footer-system-info"> (Build Version:', escape((4,  Html.BuildVersion() )), ') (Machine Name:', escape((4,  System.Environment.MachineName )), ') (Request ID:', escape((4,  OTRequestId )), ')</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Common._SeoFooter'}
,"_Spinner":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('<div id="loading_animation" class="loader"><div class="spinner"></div><div id="loading_error_container" class="loader-content"></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Common._Spinner'}
},"Redesign":{"DinersChoiceList":{"_LinkList":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var items = locals.items ; buf.push(' ');1; var itemClass = locals.itemClass ; buf.push(' ');1; var linkClass = locals.linkClass ; buf.push(' ');1; var titleClass = locals.titleClass ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; if (items.length > 0) { ; buf.push('<div class="content-section-link-lists"><ul class="', escape((1,  (titleClass) )), '"> ');1; items.forEach(function(item) { ; buf.push('<li class="', escape((1,  ( itemClass != null ? itemClass : '') )), '"> <a href="', escape((1,  (item.Uri) )), '" class="secondary">', escape((1,  (item.Name) )), '</a></li> ');1; }) ; buf.push('</ul></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.DinersChoiceList._LinkList'}
,"_LinkSection":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var linkSection = locals.linkSection ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var showRatings=linkSection.DinersChoice.Ratings.length > 0 ; buf.push(' ');1; var showCuisines=linkSection.DinersChoice.Cuisines.length > 0 ; buf.push(' ');1; var showOtherFeatures=linkSection.DinersChoice.OtherFeatures.length > 0 ; buf.push(' ');1; var showLinkSection=showRatings || showCuisines || showOtherFeatures ; buf.push(' ');1; if (showLinkSection) { ; buf.push('<div class="link-section max-width-wrapper"><h3 class="content-block-header with-border"> ');1; if (linkSection.Display.Location != null) { ; buf.push(' <span>', escape((1,  (String.Format(Resources.Shared.DinersChoiceList.Strings.LinkSectionLocationTitleFormat, linkSection.Display.Location.Name)) )), '</span> ');1; } ; buf.push('</h3> ', (1,  partial('Redesign/DinersChoiceList/_LinkList', {
    'items': linkSection.DinersChoice.Ratings,
    'itemClass': 'link rating tag-button with-icon',
    'titleClass': 'dc-links-buttons' } ) ), ' ');4; if (showCuisines) { ; buf.push('<h6> ', escape((4,  (Resources.Shared.DinersChoiceList.Strings.LinkSectionCuisinesTitle) )), '</h6> ');4; } ; buf.push(' ', (4,  partial('Redesign/DinersChoiceList/_LinkList', {
    'items': linkSection.DinersChoice.Cuisines,
    'itemClass': 'link link-list',
    'titleClass': 'dc-links-buttons' } ) ), ' ');7; if (showOtherFeatures) { ; buf.push('<h6> ', escape((7,  (Resources.Shared.DinersChoiceList.Strings.LinkSectionFeaturesTitle) )), '</h6> ');7; } ; buf.push(' ', (7,  partial('Redesign/DinersChoiceList/_LinkList', {
    'items': linkSection.DinersChoice.OtherFeatures,
    'itemClass': 'link link-list',
    'titleClass': 'dc-links-buttons'  } ) ), '</div> ');10; } ; buf.push(' ');10; if (linkSection.DinersChoice.Locations.length > 0) { ; buf.push('<div class="link-section max-width-wrapper"><h3 class="content-block-header with-border"> ');10; if (linkSection.Display.Metro != null) { ; buf.push(' <span>', escape((10,  (String.Format(Resources.Shared.DinersChoiceList.Strings.LinkSectionRegionsTitleFormat, linkSection.Display.Metro.Name)) )), '</span> ');10; } ; buf.push('</h3> ', (10,  partial('Redesign/DinersChoiceList/_LinkList', {
    'items': linkSection.DinersChoice.Locations,
    'itemClass': 'link link-list',
    'titleClass': 'dc-links-buttons' } ) ), '</div> ');13; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.DinersChoiceList._LinkSection'}
},"Filters":{"Mobile":{"_Filter":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filter = locals.filter ; buf.push(' ');1; var filterName = locals.filterName ; buf.push(' ');1; var filterDataName = locals.filterDataName ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<li> <label for="', escape((1,  (filterName) )), '_', escape((1,  (filter.Id) )), '"><input id="', escape((1,  (filterName) )), '_', escape((1,  (filter.Id) )), '" type="', escape((1,  (type) )), '" name="', escape((1,  (filterName) )), '" data-filter-name="', escape((1,  (filterDataName) )), '" data-id="', escape((1,  (filter.Id) )), '"', escape((1,  filter.IsSelected ? ' checked' : '' )), '> </input> <span>', escape((1,  (filter.Name) )), '</span></label></li>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters.Mobile._Filter'}
,"_FilterGroup":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filterGroup = locals.filterGroup ; buf.push(' ');1; var title = locals.title ; buf.push(' ');1; var name = locals.name ; buf.push(' ');1; var param = locals.param ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; if (filterGroup.length > 0) { ; buf.push('<dd class="accordion-item"> <a href="#', escape((1,  (name) )), '-filter-menu" class="accordion-link with-arrow">', escape((1,  (title) )), '</a><div id="', escape((1,  (name) )), '-filter-menu" class="accordion-content"><div class="menu-list"><ul id="', escape((1,  (name) )), '-filters" class="menu-with-checkboxes"> ');1; filterGroup.forEach(function(data, dataIndex) { ; buf.push(' ', (1,  partial('_Filter', { 'filter': data, 'filterName': param, 'filterDataName': param, 'type': 'checkbox' } ) ), ' ');1; }) ; buf.push('</ul></div></div></dd> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters.Mobile._FilterGroup'}
,"_FilterHeader":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var title = locals.title ; buf.push(' ');1; var leftLink = locals.leftLink ; buf.push(' ');1; var rightLink = locals.rightLink ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<header id="RefineHeader" class="app-header"><div class="tab-bar show-for-small-only"><div class="row"><div class="small-3 columns header-link-left"> <a id="RefineCancelLink">', escape((1,  (leftLink) )), '</a></div><div class="small-6 columns header-link-middle"><h4> ', escape((1,  (title) )), '</h4></div><div class="small-3 columns header-link-right text-right"> <a id="RefineApplyLink">', escape((1,  (rightLink) )), '</a></div></div></div></header>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters.Mobile._FilterHeader'}
,"_FilterOffers":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var offersSearchViewModel = locals.offersSearchViewModel ; buf.push(' ');1; var title = locals.title ; buf.push(' ');1; var name = locals.name ; buf.push(' ');1; var param = locals.param ; buf.push(' ');1; var filterGroupClass = locals.filterGroupClass ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = locals.Html || window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var offersFilterGroup = offersSearchViewModel.Filters.OfferTypes ; buf.push(' ');1; if (offersFilterGroup && offersFilterGroup.length > 0) { ; buf.push('<dd class="', escape((1,  filterGroupClass )), ' accordion-item"> <a href="#', escape((1,  name )), '-filter-menu" class="accordion-link with-arrow">', escape((1,  title )), '</a><div id="', escape((1,  name )), '-filter-menu" class="accordion-content"><div class="menu-list"><ul id="', escape((1,  name )), '-filters" class="menu-with-checkboxes"> ');1; offersFilterGroup.forEach(function(data, dataIndex) { ; buf.push(' ', (1,  partial('_Filter', {
              filter: data,
              filterName: param,
              filterDataName: param,
              type: 'checkbox'
            }) ), ' ');6; }) ; buf.push('</ul></div></div></dd> ');6; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters.Mobile._FilterOffers'}
,"_FilterPrice":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filterGroup = locals.filterGroup ; buf.push(' ');1; var title = locals.title ; buf.push(' ');1; var name = locals.name ; buf.push(' ');1; var param = locals.param ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; if (filterGroup.length > 0) { ; buf.push('<dd class="accordion-item"> <a href="#', escape((1,  (name) )), '-filter-menu" class="accordion-link">', escape((1,  (title) )), '</a><ul id="', escape((1,  (name) )), '-filters" class="button-group button-group-justified padding-left padding-bottom"> ');1; filterGroup.forEach(function(filter) { ; buf.push('<li> ');1; if (filter.Id == '2') { ; buf.push(' <a class="button toggle-button">', escape((1,  (String.Format("{0}{0}", Resources.Strings.Currency)) )), '</a> ');1; } ; buf.push(' ');1; if (filter.Id == '3') { ; buf.push(' <a class="button toggle-button">', escape((1,  (String.Format("{0}{0}{0}", Resources.Strings.Currency)) )), '</a> ');1; } ; buf.push(' ');1; if (filter.Id == '4') { ; buf.push(' <a class="button toggle-button">', escape((1,  (String.Format("{0}{0}{0}{0}", Resources.Strings.Currency)) )), '</a> ');1; } ; buf.push('</li> ');1; }) ; buf.push('</ul></dd> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters.Mobile._FilterPrice'}
,"_FilterSortOrder":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filters = locals.filters ; buf.push(' ');1; var filterGroupClass = locals.filterGroupClass ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="row"><div class="column medium-12 padding-top padding-bottom"><h4 class="left remove-bottom-margin"> ', escape((1,  (Resources.Shared.Redesign.Filters.Label_Sort) )), '</h4></div></div><div class="row ', escape((1,  (filterGroupClass) )), '"><div class="column medium-12"><ul class="button-group button-group-justified"><li id="SortOrder_Rating"> <a class="button toggle-button">', escape((1,  (Resources.Shared.Redesign.Filters.Label_Sort_Rating) )), '</a></li><li id="SortOrder_Popular"> <a class="button toggle-button">', escape((1,  (Resources.Shared.Redesign.Filters.Label_Sort_Popularity) )), '</a></li><li id="SortOrder_Name"> <a class="button toggle-button">', escape((1,  (Resources.Shared.Redesign.Filters.Label_Sort_Name) )), '</a></li></ul></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters.Mobile._FilterSortOrder'}
,"_Filters":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filters = locals.filters ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div id="RefineFiltersModal" class="reveal-modal"> ', (1,  partial('_FilterHeader', { 'title': Resources.Shared.Redesign.Filters.Title_RefineYourSearch, 'leftLink': Resources.Shared.Redesign.Filters.Label_Cancel, 'rightLink': Resources.Shared.Redesign.Filters.Label_Apply } ) ), '<div class="content-wrap content-wrap-centered"> ', (1,  partial('_FilterSortOrder', { 'filterGroupClass': 'filter-option filter-option-sort-orders' } ) ), ' ');1; if (filters.Filters != null) { ; buf.push('<div><div class="row"><div class="column medium-12 padding-top padding-bottom"><h4 class="left remove-bottom-margin"> ', escape((1,  Resources.Shared.Redesign.Filters.Title_Filters )), '</h4></div></div><div class="content-block"><div class="content-block-body no-padding"><dl class="accordion-menu accordion"> ', (1,  partial('_FilterPrice', {
                filterGroup: filters.Filters.PriceBands,
                title: Resources.Shared.Redesign.Filters.Title_Price,
                name: 'PriceBands',
                param: 'PriceBandIds'
              } ) ), ' ', (6,  partial('_FilterGroup', {
                filterGroup: filters.Filters.Cuisines,
                title: Resources.Shared.Redesign.Filters.Title_Cuisines,
                name: 'Cuisines',
                param: 'CuisineIds'
              } ) ), ' ', (11,  partial('_FilterOffers', {
                offersSearchViewModel: filters,
                title: Resources.Shared.Redesign.Filters.Title_OfferTypes,
                name: 'OfferTypes',
                param: 'OfferTypeIds',
                filterGroupClass: 'filter-option filter-option-offers'
              } ) ), '</dl></div></div></div> ');17; } ; buf.push('</div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters.Mobile._Filters'}
},"_Filter":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filters = locals.filters;
var filter = locals.filter;
var i = locals.index;
var filterName = locals.filterName;
var filterDataName = locals.filterDataName;
var filterSelected = filter.IsSelected;
var maxDisplay = locals.maxDisplay;
var experiments = filters.Experiments;
; buf.push(' ');9; if (filter.Id !== 'justAdded') { ; buf.push(' <label for="', escape((9,  filterName )), '_', escape((9,  filter.Id )), '" class="menu-list-label ', escape((9,  filterSelected ? 'highlight' : '' )), ' ', escape((9,  i < maxDisplay ? 'show-filter' : '' )), '"><input id="', escape((9,  filterName )), '_', escape((9,  filter.Id )), '" class="filter menu-list-input" type="', escape((9,  locals.type )), '" name="', escape((9,  filterName )), '" data-filter-name="', escape((9,  filterDataName )), '" data-id="', escape((9,  filter.Id )), '" ', escape((9,  filterSelected ? ' checked' : '' )), '> </input> ');9; var name = filterName === 'TableCategories' ?
         locals.Resources.Shared.Search.TableCategories.Categories[locals.Html.Capitalize(filter.Name)] :
         filter.Name
    ; buf.push(' <span class="underline-hover" title="', escape((12,  name )), '">');12; if (filter.Id === 'onlyExactDateTime') { ; buf.push(' ', escape((12,  String.Format(filter.Name, filters.Display.SelectedTime) )), ' ');12; } else { ; buf.push(' ', escape((12,  name )), ' ');12; } ; buf.push('</span></label> ');12; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._Filter'}
,"_FilterAvailability":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var search = locals.search ; buf.push(' ');1; var experiments = locals.experiments ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push('<span class="filters"><span class="availability-icon filter-icon"></span> <span class="filter-list-title">Availability</span></span><div class="dtp-filter"> ');1; for (var i = 0; i < 3; i++) { ; buf.push('<div class="dtp-picker-selector"></div> ');1; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterAvailability'}
,"_FilterGroup":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filters = locals.filters ; buf.push(' ');1; var filterGroup = locals.filterGroup ; buf.push(' ');1; var title = locals.title ; buf.push(' ');1; var name = locals.name ; buf.push(' ');1; var param = locals.param ; buf.push(' ');1; var selectedCount = locals.selectedCount ; buf.push(' ');1; var filterToggleTitle = locals.filterToggleTitle ; buf.push(' ');1; var experiments = filters.Experiments ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var maxFiltersShowing = 6 ; buf.push(' ');1; var filtersOverflow = filterGroup.length >= maxFiltersShowing ; buf.push(' ');1; var iconClass = locals.iconClass ; buf.push(' ');1; var classes = ['filter-toggle', 'menu-list-label'];
  if (selectedCount > 0 && selectedCount < filterGroup.length) {
    classes.push('partial');
  }
  if (selectedCount == filterGroup.length) {
    classes.push('highlight');
  }
  if (param === 'OfferTypeIds') {
    // All Offers should always be visible
    classes.push('show-filter');
    maxFiltersShowing = 5;
  }
; buf.push(' ');13; if (filterGroup.length > 0) { ; buf.push('<span data-target="', escape((13,  name )), '-filter-menu" class="filters"><span class="', (13,  iconClass ), '-icon filter-icon"></span> <span class="filter-list-title">', escape((13,  title )), '</span> <span class="filter-count">');13; if (selectedCount > 0) { ; buf.push('(', escape((13,  selectedCount )), ')');13; } ; buf.push('</span></span><div id="', escape((13,  name )), '-filter-menu" class="menu with-arrow search-filter-menu"><div class="menu-container"><div class="menu-main collapsed"><div class="menu-section ', (13,  filtersOverflow ? 'with-scroll' : '' ), '"><div class="menu-list ', (13,  filtersOverflow ? 'with-overflow' : '' ), '"><div id="', escape((13,  name )), '-filter-items" class="menu-with-checkboxes"><ul class="view-filter-list"> ');13; if (name !== 'Regions') { ; buf.push(' ');13; if (param !== 'TimeIds' && param !== 'LoyaltyRedemptionsIds') { ; buf.push(' ');13; var id = name + '_All'; ; buf.push('<li> <label for="', escape((13,  id )), '" class="', escape((13,  classes.join(' ') )), '"><input id="', escape((13,  id )), '" class="menu-list-input all-filter", name="', escape((13,  name )), '" data-id="All" type="checkbox" ', escape((13,  selectedCount == filterGroup.length ? ' checked' : '' )), '/> <span title="', escape((13,  filterToggleTitle )), '">', escape((13,  filterToggleTitle )), '</span></label></li> ');13; } ; buf.push(' ');13; } ; buf.push(' ');13; filterGroup.forEach(function(data, dataIndex) { ; buf.push('<li>', (13,  partial('_Filter', {
                    filters: filters,
                    filter: data,
                    index: dataIndex,
                    filterName: name,
                    filterDataName: param,
                    type: 'checkbox',
                    maxDisplay: maxFiltersShowing
                  }) ), '</li> ');21; }) ; buf.push('</ul></div></div></div> ');21; if (filtersOverflow) { ; buf.push(' <span data-menu="', escape((21,  name )), '-filter-menu" class="see-filters"><span class="with-arrow text-arrow-down"><span class="underline-hover">', escape((21,  experiments.sv2391 ? Resources.Shared.Common.Filters.MoreLink : Resources.Shared.Common.Filters.Expand_Link )), '</span></span> <span class="with-arrow text-arrow-up"><span class="underline-hover">', escape((21,  experiments.sv2391 ? Resources.Shared.Redesign.Strings.Less : Resources.Shared.Common.Filters.Collapse_Link )), '</span></span></span> ');21; } ; buf.push('</div></div></div> ');21; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterGroup'}
,"_FilterLocationGroup":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filterLocationGroup = locals.filterLocationGroup ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var milesToDisplay = locals.helpers.milesToDisplay ; buf.push(' ');1; var displayToMiles = locals.helpers.displayToMiles ; buf.push(' ');1; if (filterLocationGroup.Request.IsGeoDistanceRequest && filterLocationGroup.Experiments.range) { ; buf.push(' <span data-target="distance-filter-menu" class="filters">', escape((1,  Resources.Shared.Redesign.Filters.Title_Range )), ' <span class="filter-distance">', escape((1,  milesToDisplay(filterLocationGroup.Request.Distance, Resources.Strings.DistanceUnit_Small) )), '</span> ', escape((1,  Resources.Strings.DistanceUnit_Small )), '</span><div id="distance-filter-menu" class="menu with-arrow"><div class="menu-container"><div class="menu-main"><div class="menu-header"> ', escape((1,  Resources.Shared.Redesign.Filters.Label_FilterBy_Range )), '</div><div class="menu-section"><div class="menu-list"><div id="distance-filters" class="menu-with-checkboxes"> ');1; filterLocationGroup.Display.DistanceOptions.forEach(function(option, optionIndex) { ; buf.push(' ');1; var distanceText = option.Value + ' ' + Resources.Strings.DistanceUnit ; buf.push(' ');1; var distanceMiles = displayToMiles(option.Value, Resources.Strings.DistanceUnit_Small) ; buf.push(' ');1; var isSelected = filterLocationGroup.Request.Distance == distanceMiles || option.IsSelected ; buf.push(' <label for="within_radius_', escape((1,  distanceMiles )), '" class="menu-list-label ', escape((1,  isSelected ? 'highlight' : '' )), '"><input type="radio" id="within_radius_', escape((1,  distanceMiles )), '" name="within_radius" value="', escape((1,  distanceMiles )), '" ', escape((1,  isSelected ? ' checked' : '' )), ' data-filter-name="Distance" data-singular="true" data-id="', escape((1,  distanceMiles )), '" data-original-distance="', escape((1,  option.Value )), '" class="filter menu-list-input"> </input> <span title="', escape((1,  distanceText )), '">', escape((1,  distanceText )), '</span></label> ');1; }) ; buf.push('</div></div></div></div></div></div> ');1;} else {; buf.push(' ');1; if ((filterLocationGroup.Request.RegionIds == null && filterLocationGroup.Request.NeighborhoodIds == null && !filterLocationGroup.Request.IsAreaIdRequest) || (filterLocationGroup.Request.ParsedRegionIds && filterLocationGroup.Request.ParsedRegionIds.length > 1)) { ; buf.push(' ', (1,  partial('_FilterGroup', {
      filters: filterLocationGroup,
      filterGroup: filterLocationGroup.Filters.Regions,
      title: Resources.Shared.Redesign.Filters.Title_Regions,
      modalTitle: Resources.Shared.Redesign.Filters.Title_Regions,
      name: 'Regions',
      param: 'RegionIds',
      selectedCount: filterLocationGroup.Filters.SelectedRegionCount,
      filterToggleTitle: Resources.Shared.Redesign.Filters.All_Locations,
      iconClass: 'location'
    }) ), ' ');11;} else {; buf.push(' ', (11,  partial('_FilterGroup', {
      filters: filterLocationGroup,
      filterGroup: filterLocationGroup.Filters.Neighborhoods,
      title: Resources.Shared.Redesign.Results.Header_Area,
      modalTitle: Resources.Shared.Redesign.Results.Header_Area,
      name: 'Neighborhoods',
      param: 'NeighborhoodIds',
      selectedCount: filterLocationGroup.Filters.SelectedNeighborhoodCount,
      filterToggleTitle: Resources.Shared.Redesign.Filters.All_Locations,
      iconClass: 'location'
    }) ), ' ');21; } ; buf.push(' ');21; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterLocationGroup'}
,"_FilterSortOrder":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var request = locals.request ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model || locals.filterSortOrder ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var experiments = locals.experiments || {} ; buf.push(' ');1; var showDistance = locals.showDistance ; buf.push(' ');1; var sortingOptions = {
  Distance: Resources.Shared.Redesign.Filters.Label_Sort_Distance,
  Popularity: Resources.Shared.Redesign.Filters.Label_Sort_Popularity,
  Name: Resources.Shared.Redesign.Filters.Label_Sort_Name,
  Rating: Resources.Shared.Redesign.Filters.Label_Sort_Rating,
  TimeDistance: Resources.Shared.Redesign.Filters.Label_Sort_Distance
  } ; buf.push(' ');7; var sortBy = '<span class="sorting-label">' + sortingOptions[request.SortString] + '</span>' ; buf.push(' ');7; var sortLabel = experiments.sv2046 ? String.Format(Resources.Shared.Redesign.Strings.Label_SortBy, sortBy) : Resources.Shared.Redesign.Strings.Label_Sort ; buf.push('<div class="sort-order-with-menu"> <span data-target="sort-filter-menu" id="filter-button-toggle" class="filters icon-as-button button--no-hover" title="', escape((7,  Resources.Shared.Redesign.Strings.Label_Sort )), '">');7; if (!experiments.sv2046) { ; buf.push('<span class="sort-icon"></span> ');7; } ; buf.push(' <span class="current-sort-order pref-label underline-hover', escape((7,  experiments.sv2046 ? ' text-arrow-down' : '' )), '">', (7,  sortLabel ), '</span></span><div id="sort-filter-menu" class="menu with-arrow"><div class="menu-container"><div class="menu-main"><div class="menu-section"><div class="menu-list"> ');7; var selectedDistance=request.SortString == 'Distance' ; buf.push(' ');7; var selectedPopularity=request.SortString == 'Popularity' ; buf.push(' ');7; var selectedName=request.SortString == 'Name' ; buf.push(' ');7; var selectedRating=request.SortString == 'Rating' ; buf.push(' ');7; var selectedTimeDistance=request.SortString == 'TimeDistance' ; buf.push('<div id="sort-filter-items" class="menu-with-checkboxes"> ');7; if (request.IsGeoDistanceRequest || showDistance) { ; buf.push(' <label for="SortOrder_Distance" class="menu-list-label  ', escape((7,  selectedDistance ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Distance" name="SortOrder" class="menu-list-input sort-option" value="Distance"', escape((7,  selectedDistance ? ' checked' : '' )), '></input> <span>', escape((7,  sortingOptions.TimeDistance )), '</span></label> ');7; } ; buf.push(' <label for="SortOrder_Popular" class="menu-list-label ', escape((7,  selectedPopularity ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Popular" name="SortOrder" class="menu-list-input sort-option" value="Popularity"', escape((7,  selectedPopularity ? ' checked' : '' )), '></input> <span>', escape((7,  sortingOptions.Popularity )), '</span></label> <label for="SortOrder_Name" class="menu-list-label  ', escape((7,  selectedName ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Name" name="SortOrder" class="menu-list-input sort-option" value="Name"', escape((7,  selectedName ? ' checked' : '' )), '></input> <span>', escape((7,  sortingOptions.Name )), '</span></label> <label for="SortOrder_Rating" class="menu-list-label ', escape((7,  selectedRating ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Rating" name="SortOrder" class="menu-list-input sort-option" value="Rating"', escape((7,  selectedRating ? ' checked' : '' )), '></input> <span>', escape((7,  sortingOptions.Rating )), '</span></label></div></div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterSortOrder'}
,"_FilterViewOptions":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filterViewOptions = locals.filterViewOptions ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; if (filterViewOptions.Display.ShowMapTab) { ; buf.push('<div class="views" id="view_toggle"><div data-view="list" class="icon-as-button ', escape((1,  filterViewOptions.Display.CurrentView === 'list'  ? 'selected' : '' )), '"><svg class="sort-view-toggle-icon" viewBox="0 0 33 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M7.88020833.5 7.88020833 3.5 32.796875 3.5 32.796875.5 7.88020833.5ZM7.88020833 15.8984375 32.796875 15.8984375 32.796875 12.8984375 7.88020833 12.8984375 7.88020833 15.8984375ZM7.88020833 28.3203125 32.796875 28.3203125 32.796875 25.3203125 7.88020833 25.3203125 7.88020833 28.3203125ZM0 4 4 4 4 0 0 0 0 4ZM0 16.421875 4 16.421875 4 12.421875 0 12.421875 0 16.421875ZM0 28.84375 4 28.84375 4 24.84375 0 24.84375 0 28.84375Z" class="svg-list-icon"></path></svg><span class="pref-label">', escape((1,  Resources.Shared.Search.Tabs.List )), '</span></div> ');1; if (filterViewOptions.Experiments.sv2390) { ; buf.push('<div data-view="map" class="icon-as-button ', escape((1,  filterViewOptions.Display.CurrentView === 'map'  ? 'selected' : '' )), '"><svg class="sort-view-toggle-icon" viewBox="0 1 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M13 3.5 7.4.9l0 0L.9 3.5v15.7l6.5-2.6 5.6 2.5 0 0 6-2.6.1 0V.8L13 3.5zM13.5 17.4V4.7L17.8 3v12.6L13.5 17.4zM12.1 4.4v13l-4.3-1.9v-13L12.1 4.4zM6.5 2.8v12.6L2.2 17V4.4L6.5 2.8z" id="Combined-Shape" class="svg-map-icon"></path></svg><span class="pref-label">', escape((1,  Resources.Shared.Search.Tabs.Map )), '</span></div> ');1; } else { ; buf.push('<div data-view="map" class="icon-as-button ', escape((1,  filterViewOptions.Display.CurrentView === 'map'  ? 'selected' : '' )), '"><svg class="sort-view-toggle-icon" viewBox="0 0 28 35" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M24.2530539 23.3333333C26.4321056 21 27.7587364 17.1686667 27.7587364 13.7678333 27.7587364 6.4015 21.5442751 0 13.879426 0 6.21457687 0 .00011566092 6.57883333.00011566092 13.9451667.00011566092 17.3448333 1.3255898 21 3.50579813 23.3333333L3.46994325 23.3333333 13.879426 35 24.2889088 23.3333333 24.2530539 23.3333333ZM18.5057471 13.3124833C18.5057471 15.88965 16.4342601 17.97915 13.8793103 17.97915 11.3243606 17.97915 9.25287356 15.88965 9.25287356 13.3124833 9.25287356 10.7353167 11.3243606 8.64581667 13.8793103 8.64581667 16.4342601 8.64581667 18.5057471 10.7353167 18.5057471 13.3124833Z" id="Combined-Shape" class="svg-map-icon"></path></svg><span class="pref-label">', escape((1,  Resources.Shared.Search.Tabs.Map )), '</span></div> ');1; } ; buf.push('</div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterViewOptions'}
,"_Filters":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filters = locals.filters ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var experiments = filters.Experiments ; buf.push('<div id="search_filters"> ');1; if (filters.Results.TotalAvailable) { ; buf.push(' ');1; if (experiments.sv1467 === 2) {; buf.push('<div id="restore-search" class="restore-search text-arrow-right"> ', (1,  Resources.Shared.Search.Results.RestoreSearch ), '</div> ');1; } ; buf.push('<ul class="filters-list"> ');1; if (experiments.sv2046) { ; buf.push('<li class="sort-view-filters"><div class="search-tab view-toggle"> ', (1,  partial('Redesign/Filters/_FilterViewOptions', {
              filterViewOptions: filters
            }) ), '</div></li> ');3; } ; buf.push(' ');3; if (experiments.sv1369 && filters.Filters.MyLists && filters.Filters.MyLists.length) { ; buf.push('<li id="mylist_filters" class="filter-option filter-option-mylists"> ', (3,  partial('_FilterGroup', {
            filters: filters,
            filterGroup: filters.Filters.MyLists,
            title: Resources.Shared.Redesign.Filters.Title_MyLists,
            modalTitle: Resources.Shared.Redesign.Filters.Title_MyLists,
            name: 'MyLists',
            param: 'MyListIds',
            selectedCount: filters.Filters.SelectedMyListsCount,
            filterToggleTitle: Resources.Shared.Redesign.Filters.All_MyLists,
            iconClass: 'list'
          }) ), '</li> ');13; } ; buf.push(' ');13; if (filters.Filters.LoyaltyRedemptions && filters.Filters.LoyaltyRedemptions.length) { ; buf.push('<li id="loyaltyredemption_filters" class="filter-option filter-option-loyaltyredemptions"> ', (13,  partial('_FilterGroup', {
            filters: filters,
            filterGroup: filters.Filters.LoyaltyRedemptions,
            title: Resources.Shared.Common.Filters.Title_Loyalty_Redemptions,
            modalTitle: Resources.Shared.Common.Filters.Title_Loyalty_Redemptions,
            name: 'LoyaltyRedemptions',
            param: 'LoyaltyRedemptionsIds',
            selectedCount: filters.Filters.SelectedLoyaltyRedemptionsCount,
            filterToggleTitle: Resources.Shared.Redesign.Filters.All_Loyalty_Redemptions,
            iconClass: 'loyalty'
          }) ), '</li> ');23; } ; buf.push(' ');23; if (filters.Display.ShowLocationsFilter
      && filters.Filters.Regions && filters.Filters.Regions.length
      || filters.Filters.Neighborhoods && filters.Filters.Neighborhoods.length) { ; buf.push('<li id="location_filters" class="filter-option filter-option-locations"> ', (25,  partial('_FilterLocationGroup', {
            filterLocationGroup: filters
          }) ), '</li> ');27; } ; buf.push(' ');27; if (filters.Display.ShowCuisineFilter && filters.Filters.Cuisines && filters.Filters.Cuisines.length) { ; buf.push('<li id="cuisine_filters" class="filter-option filter-option-cuisines"> ', (27,  partial('_FilterGroup', {
            filters: filters,
            filterGroup: filters.Filters.Cuisines,
            title: Resources.Shared.Redesign.Filters.Title_Cuisines,
            modalTitle: Resources.Shared.Redesign.Filters.Title_Cuisines,
            name: 'Cuisines',
            param: 'CuisineIds',
            selectedCount: filters.Filters.SelectedCuisineCount,
            filterToggleTitle: Resources.Shared.Redesign.Filters.All_Cuisines,
            iconClass: 'cuisine'
          }) ), '</li> ');37; } ; buf.push(' ');37; if (filters.Display.ShowOffersFilter && filters.Filters.OfferTypes && filters.Filters.OfferTypes.length) { ; buf.push('<li id="offer_type_filters" class="filter-option filter-option-offers"> ', (37,  partial('_FilterGroup', {
            filters: filters,
            filterGroup: filters.Filters.OfferTypes,
            title: Resources.Shared.Redesign.Filters.Title_OfferTypes,
            modalTitle: Resources.Shared.Redesign.Filters.Title_OfferTypes,
            name: 'OfferTypes',
            param: 'OfferTypeIds',
            selectedCount: filters.Filters.SelectedOfferTypeCount,
            filterToggleTitle: Resources.Shared.Redesign.Filters.All_Offers,
            iconClass: 'offers'
          }) ), '</li> ');47; } ; buf.push(' ');47; if (filters.Display.ShowPrices && filters.Filters.PriceBands && filters.Filters.PriceBands.length) { ; buf.push('<li id="price_band_filters" class="filter-option filter-option-prices"> ', (47,  partial('_FilterGroup', {
            filters: filters,
            filterGroup: filters.Filters.PriceBands,
            title: Resources.Shared.Redesign.Filters.Title_Price,
            modalTitle: Resources.Shared.Redesign.Filters.Title_Price,
            name: 'PriceBands',
            param: 'PriceBandIds',
            selectedCount: filters.Filters.SelectedPriceBandCount,
            filterToggleTitle: Resources.Shared.Redesign.Filters.All_Prices,
            iconClass: 'payment'
          }) ), '</li> ');57; } ; buf.push(' ');57; if (filters.Filters.Tags && filters.Filters.Tags.length && filters.DomainCulture.Language === 'en') { ; buf.push('<li id="tag_filters" class="filter-option filter-option-tags"> ', (57,  partial('_FilterGroup', {
            filters: filters,
            filterGroup: filters.Filters.Tags,
            title: Resources.Shared.Redesign.Filters.Title_Tags,
            modalTitle: Resources.Shared.Redesign.Filters.Title_Tags,
            name: 'Tags',
            param: 'TagIds',
            selectedCount: filters.Filters.SelectedTagsCount,
            filterToggleTitle: Resources.Shared.Redesign.Filters.All_Tags,
            iconClass: 'top-rated'
          }) ), '</li> ');67; } ; buf.push(' ');67; if (filters.Results.TotalAvailable && (filters.Display.ShowPopFilter || filters.Display.ShowExactTimeFilter)) { ; buf.push('<li id="time_filters" class="filter-option filter-option-times"> ');67; var title = experiments.sv1128 ? Resources.Shared.Redesign.Filters.Title_Featured : Resources.Shared.Redesign.Filters.Title_Time ; buf.push(' ');67; var iconClass = experiments.sv1128 ? 'featured' : 'time' ; buf.push(' ', (67,  partial('_FilterGroup', {
          filters: filters,
          filterGroup: filters.Filters.Times,
          title: title,
          modalTitle: title,
          name: 'Times',
          param: 'TimeIds',
          selectedCount: filters.Filters.SelectedTimeCount,
          filterToggleTitle: title,
          iconClass: iconClass
        }) ), '</li> ');77; } ; buf.push(' ');77; if (experiments.sv2134 && filters.Filters.TableCategories && filters.Filters.TableCategories.length > 1) { ; buf.push('<li id="table_categories_filters" class="filter-option filter-option-table-categories"> ', (77,  partial('_FilterGroup', {
          filters: filters,
          filterGroup: filters.Filters.TableCategories,
          title: 'Table Categories',
          modalTitle: '',
          name: 'TableCategories',
          param: 'TableCategories',
          selectedCount: filters.Filters.SelectedTableCategoriesCount,
          filterToggleTitle: 'All Table Categories',
          iconClass: 'table-category'
        }) ), '</li> ');87; } ; buf.push('</ul> ');87; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._Filters'}
},"Modals":{"SingleSearchModal":{"_DatePicker":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('<div class="date-picker dtp-picker-selector"><a class="dtp-picker-selector-link"><div class="date-label dtp-picker-label"> Today</div> <input type="hidden" name="datepicker" class="datepicker dtp-picker-select" aria-label="today"> </input></a></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals.SingleSearchModal._DatePicker'}
,"_PartySizePicker":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var model = locals.Model ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="party-size-picker dtp-picker-selector"> <a data-target=".menu" class="party-size-label dtp-picker-selector-link toggle-menu">', escape((1,  (model.SelectedCovers) )), '</a><div class="menu with-arrow"><div class="menu-container"><div class="menu-main"><div class="menu-section  js-lionbars"><div class="menu-list"><div id="single-search-modal-party-size-filters" class="menu-with-checkboxes"> ');1; model.CoverOptions.forEach(function(option, optionIndex) { ; buf.push(' <label for="SingleSearch_PartySize_', escape((1,  (option.Value) )), '" class="menu-list-label ', escape((1,  ( option.IsSelected ? 'highlight' : '') )), '"><input type="radio" id="SingleSearch_PartySize_', escape((1,  (option.Value) )), '" name="SingleSearch_PartySize" class="menu-list-input party-size-option" value="', escape((1,  (option.Value) )), '"', escape((1,  option.IsSelected ? ' checked' : '' )), '> </input> <span>', escape((1,  (option.Text) )), '</span></label> ');1; }) ; buf.push('</div></div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals.SingleSearchModal._PartySizePicker'}
,"_TimePicker":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var model = locals.Model ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="time-picker dtp-picker-selector"><a data-target=".menu" class="time-label dtp-picker-selector-link toggle-menu"></a><div class="menu with-arrow"><div class="menu-container"><div class="menu-main"><div class="menu-section js-lionbars"><div class="menu-list"><div class="menu-with-checkboxes"> ');1; model.TimeOptions.forEach(function(option, optionIndex) { ; buf.push(' <label for="SingleSearch_Time_', escape((1,  (option.Value) )), '" class="menu-list-label ', escape((1,  ( option.IsSelected ? 'highlight' : '') )), '"><input type="radio" id="SingleSearch_Time_', escape((1,  (option.Value) )), '" name="SingleSearch_Time" class="menu-list-input time-option" value="', escape((1,  (option.Value) )), '"', escape((1,  option.IsSelected ? ' checked' : '' )), '> </input> <span>', escape((1,  (option.Text) )), '</span></label> ');1; }) ; buf.push('</div></div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals.SingleSearchModal._TimePicker'}
},"_OffersTooltip":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var offersTooltip = locals.offersTooltip ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="menu dn menu-opened"><div class="menu-container"><div class="menu-main"><div class="menu-header"> ');1; if (offersTooltip.Offers.length > 1) { ; buf.push(' <strong>', escape((1,  (String.Format(Resources.Shared.Common.Modals.Offers_TooltipHeaderMultiple,offersTooltip.Offers.length)) )), '</strong> ');1; } ; buf.push(' ');1; if (offersTooltip.Offers.length == 1) { ; buf.push(' <strong>', escape((1,  (String.Format(Resources.Shared.Common.Modals.Offers_TooltipHeaderSingle)) )), '</strong> ');1; } ; buf.push('</div><div class="modal-list tooltip-offers"> ');1; offersTooltip.Offers.forEach(function(offer) { ; buf.push(' <label class="offer menu-list-label">', escape((1,  (offer) )), '</label> ');1; }) ; buf.push('</div></div><div class="dn-arrow"></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._OffersTooltip'}
,"_PremiumAccessBookModal":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Resources = locals.Resources || window.Resources ; buf.push('<div class="premium_access-book_dialog"><div class="premium_access-book_dialog-image_container"><div class="premium_access-book_dialog-image"></div></div><div class="premium_access-book_dialog-content"><div class="premium_access-book_dialog-content-text"> ', escape((1,  Resources.Shared.Redesign.PremiumAccess.BookText )), ' <a href="javascript:void(0)" class="js-premium_access-book_modal-learn_more">', escape((1,  Resources.Shared.Redesign.PremiumAccess.LearnMore )), '</a></div><div class="premium_access-book_dialog-button_container"></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._PremiumAccessBookModal'}
,"_PremiumAccessCallout":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Resources = locals.Resources || window.Resources ; buf.push('<div class="js-premium_access-callout_bubble premium_access-callout_bubble"><div class="premium_access-callout_bubble-content"><div class="premium_access-callout_bubble-title_bar"><div class="premium_access-callout_bubble-title"> ', escape((1,  Resources.Shared.Redesign.PremiumAccess.Tables )), '</div><div class="site-alert-close icon-close premium_access-callout_bubble-close_icon js-premium_access-callout_bubble-close_icon"></div></div><div class="premium_access-callout_bubble-text"> ', escape((1,  Resources.Shared.Redesign.PremiumAccess.CalloutText )), '</div><div class="premium_access-callout_bubble-button_area"> <a href="javascript:void(0)" class="button js-premium_access-callout_bubble-dismiss_button premium_access-callout_bubble-dismiss_button">', escape((1,  Resources.Shared.Redesign.PremiumAccess.GotIt )), '</a> <a href="javascript:void(0)" class="button js-premium_access-learn_more premium_access-callout_bubble-learn_more_button">', escape((1,  Resources.Shared.Redesign.PremiumAccess.LearnMore )), '</a></div></div><div class="premium_access-callout_bubble-triangle"></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._PremiumAccessCallout'}
,"_RestaurantModal":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var restaurantModal = locals.restaurantModal ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="menu menu-opened"><div class="menu-container"><div class="menu-main"><div class="restaurant-data"><div class="menu-header"> ', escape((1,  (Resources.Shared.Common.Modals.Restaurant_SpecialOffers) )), '</div><div class="modal-list offer-info"> ');1; restaurantModal.forEach(function(offer) { ; buf.push('<div> <label class="menu-list-label">', escape((1,  (offer.Name) )), '</label></div> ');1; }) ; buf.push('</div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._RestaurantModal'}
,"_SingleSearchModal":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var singleSearchModalModel = locals.singleSearchModalModel ; buf.push(' ');1; var _ = locals.underscore || window._ ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; if (singleSearchModalModel.Display.ShowSingleSearchInResults) { ; buf.push('<div id="single-search-modal-placeholder" class="modal" style="display: none" data-pre-selected-date="', escape((1,  (singleSearchModalModel.Display.SingleSearchSelectedIsoDateTime) )), '"><div id="single-search-modal"><p> ', (1,  String.Format(_.escape(Resources.Shared.Common.Modals.SingleSearch_ReserveAt), '<span id="restaurant-name"></span>') ), '</p><div class="row"> ', (1,  Html.RenderAction("DateTimePartySize", "Srs", { domainCulture:singleSearchModalModel.DomainCulture, showSearch:false, selectedCovers:singleSearchModalModel.Request.Covers, selectedDateTime:singleSearchModalModel.Display.SelectedIsoDateTime, metro:Model.Display.Metro }) ), '</div></div><i class="icon icon-single-search-modal top"></i><i class="icon icon-single-search-modal bottom"></i></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._SingleSearchModal'}
,"_TableCategoriesModal":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Model = locals.Model ; buf.push(' ');1; var Resources = locals.Resources ; buf.push(' ');1; var translations = Resources.Shared.Search.TableCategories;
var tableCategories = Object.keys(translations.Categories).map(function(category) {
  return category[0].toLowerCase() + category.slice(1, category.length);
}); ; buf.push('<div class="modal-container table-categories-overlay" id="table-categories-overlay"><div class="modal-close"></div><div class="modal-content"><div class="modal-content-body table-selector"><div class="content-block table-selector-content" data-select-translation="', escape((4,  translations.Select )), '" data-unavailable-translation="', escape((4,  translations.Unavailable )), '"><div class="table-selector-header"><h3>', escape((4,  translations.ModalTitle )), '</h3></div><div class="category-rows"> ');4; tableCategories.forEach(function(el) { ; buf.push('<div class="category-row" data-category="', escape((4,  el )), '" data-standard-category="', escape((4,  el === "default" )), '"><div class="left category-name"> ', escape((4,  translations.Categories[el[0].toUpperCase() + el.slice(1, el.length)] )), '</div> <a href class="right button category-button" target="_blank" data-href-addon="', (4,  '&st=Standard&papa=&tc=' + el ), '">', escape((4,  translations.Select )), '</a></div> ');4; }) ; buf.push('</div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._TableCategoriesModal'}
},"Results":{"_AvailabilityLink":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var availabilityLink = locals.availabilityLink ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; if (availabilityLink.Request.IsAvailabilityRequest) { ; buf.push(' ');1; if (availabilityLink.Request.OnlyUnavailable == true && availabilityLink.Results.TotalAvailable > 0) { ; buf.push(' ');1; var linkText=String.Format(availabilityLink.Results.TotalAvailable == 1 ? Resources.Shared.Redesign.Results.WithAvailabilityLink : Resources.Shared.Redesign.Results.WithAvailabilityLink_Plural, availabilityLink.Results.TotalAvailable) ; buf.push(' <a id="availability_link" class="availability-link"><span class="underline-hover">', escape((1,  linkText )), '</span></a> ');1; } else if (
      (!availabilityLink.Request.Personalizer && !availabilityLink.Request.OnlyUnavailable && availabilityLink.Results.TotalUnavailable > 0) ||
      (availabilityLink.Request.Personalizer && !availabilityLink.Request.IntersperseAvailability && availabilityLink.Results.TotalUnavailable > 0)) { ; buf.push(' ');3;
      // For personalizer, we don't have a great indicator of when to show the
      // IntersperseAvailability link, so only show it when there may be
      // unavailable results, and hide it when IntersperseAvailability is false

      //TODO Once IncludeInterspercedAvailabilityText has the format
      //     placeholder removed, we can remove the String.Format and all references
      //     to TotalUnavailable, which isn't supported by personalizer.
    ; buf.push('<p class="not-shown-message">', escape((11,  (String.Format(Resources.Shared.Redesign.Results.IncludeInterspercedAvailabilityText, availabilityLink.Results.TotalUnavailable)) )), '</p> <a id="availability_link" class="text-arrow-right with-availability"><span class="underline-hover">', escape((11,  Resources.Shared.Redesign.Results.IncludeInterspercedAvailabilityLink )), '</span></a> ');11; } ; buf.push(' ');11; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._AvailabilityLink'}
,"_DateAdded":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var dateAddedRestaurant = locals.dateAddedRestaurant ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ', escape((1,  (dateAddedRestaurant.DateAdded) )), '');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._DateAdded'}
,"_FreeTextBlurb":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1;
  var lookup = locals.lookup;
  var freeTextBaseCheck = locals.freeTextBaseCheck;
  var restaurant = locals.restaurant;

  var freeTextBlurb = '';
  if (freeTextBaseCheck) {
    var single = {};
    single[lookup[restaurant.FreeText.SingleRelevanceSource]] = [restaurant.FreeText.SingleRelevance];
    var type = Object.keys(single)[0];
    var freeTextMatch = single[type].toString();
    var addEllipsis = '&hellip;'
    if (type !== 'Menu') {
      // Converts a randomly chopped sentence into one ending in ...
      freeTextMatch = freeTextMatch.trim().replace(/^([.,'’\/!?$%\^&\*;:}=\-_`~ )]*)/gm, '').trim();
      if (freeTextMatch[0] !== freeTextMatch[0].toUpperCase()) {
        freeTextMatch = '&hellip;' + freeTextMatch;
      }
      if (type === 'Description' || !('.!?'.indexOf(freeTextMatch.slice(-1)) !== -1)) {
        freeTextMatch += '&hellip;';
      }
    }
  }
; buf.push('<div class="freetext"><span class="freetext-item"><span class="freetext-icon freetext-', escape((24,  type.toLowerCase() )), '-icon"></span> <span class="freetext-match freetext-match-', escape((24,  type.toLowerCase() )), '"><span class="match">', (24,  freeTextMatch ), '</span></span></span></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._FreeTextBlurb'}
,"_MyListsNoResults":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var noResults = locals.noResults ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var hasMetro = (noResults.MyListsOptions && noResults.MyListsOptions.LastVisitedMetro) ; buf.push(' ');1; var myListsResource = Resources.Shared.MyLists.Strings[noResults.MyListsOptions.Type] ; buf.push('<div class="content-section-header no-results"><h3 class="color-dark"> ', escape((1,  (String.Format(myListsResource.NoResultsTitleFormat, noResults.MyListsOptions.Name)) )), '</h3><div class="block"><p class="no-result-message"> ', escape((1,  (myListsResource.NoResultsSubTitle) )), '</p> ');1; if (hasMetro) { ; buf.push(' <a id="no-results-start-over" class="button" href="/rest_list.aspx?m=', escape((1,  (noResults.MyListsOptions.LastVisitedMetro) )), '">', escape((1,  (myListsResource.NoResultsActionButton) )), '</a> ');1; } else { ; buf.push(' <a id="no-results-start-over" class="button" href="/start/home">', escape((1,  (myListsResource.NoResultsActionButton) )), '</a> ');1; } ; buf.push('</div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._MyListsNoResults'}
,"_NoResults":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1;
var noResults = locals.noResults;
var clearLastFilter = locals.clearLastFilter;
var AdvertType = locals.AdvertType;
var Html = !!locals.Html ? locals.Html : window.Html;
var PageType = locals.PageType;
var Request = locals.Request;
var Resources = !!locals.Resources ? locals.Resources : window.Resources;
var SrsPageType = locals.SrsPageType;
var System = locals.System;
var block = locals.block;
var layout = locals.layout;
var partial = locals.partial;
var metro = noResults.Display.Metro;
var isMyListsView = noResults.IsMyListsView;
var isFreeTextSearch = noResults.Request.Term;
var metroName = noResults.Display.Metro.Name || ''; // to prevent printing 'null' when no metroid is provided
; buf.push('<div class="content-section-header no-results"> ');18; if (noResults.Display.ShowDescriptionForZeroResults && !String.IsNullOrEmpty(noResults.Display.PageMetaData.Description)) { ; buf.push('<p id="page-description" class="page-description"> ', (18,  noResults.Display.PageMetaData.Description ), '</p> ');18; } ; buf.push('<h3 class="color-dark"> ', escape((18,  Resources.Shared.Redesign.NoResults.Heading )), '</h3><div class="block"><p class="no-result-message"> ');18; if (isFreeTextSearch) { ; buf.push(' ', (18, 
        String.Format(
          Resources.Shared.Search.FreeTextSearch.NoResultsMessage,
          partial('Redesign/Results/_NoResultsFreeText', { })
        )
        ), ' ');23; } ; buf.push(' ');23; if (!noResults.Results.TotalAvailable && !isFreeTextSearch) { ; buf.push(' ', escape((23,  Resources.Shared.Search.Strings.NoSearchResults_NoMatch_Message )), ' ');23; } else { ; buf.push(' ', escape((23,  Resources.Shared.Search.Strings.NoSearchResults_NoMatch_Message_Freetext )), ' ');23; } ; buf.push('</p> ');23; if (clearLastFilter) { ; buf.push(' <button id="clear_last_filter" class="button"> ', escape((23,  Resources.Shared.Search.Strings.NoSearchResults_UndoLastFilterButton )), '</button> ');23; if (!noResults.Results.TotalAvailable) { ; buf.push(' <span class="or">', escape((23,  Resources.Shared.Search.Strings.NoSearchResults_Or )), '</span> ');23; } ; buf.push(' ');23; } ; buf.push(' ');23; if (!noResults.Results.TotalAvailable || isFreeTextSearch) { ; buf.push(' <button id="start_over" class="button"> ', escape((23,  Resources.Shared.Search.Strings.NoSearchResults_StartOverButton )), '</button> ');23; } ; buf.push('</div> ');23; if (!isMyListsView && !noResults.Results.TotalAvailable) { ; buf.push('<h3 class="color-dark"> ', escape((23,  Resources.Shared.Redesign.NoResults.OtherSuggestionsHeading )), '</h3><div class="block"><div> <a href="', escape((23,  noResults.Request.MetroId ? '/s/restaurantlist?metroid=' + noResults.Request.MetroId : '/' )), '" class="link no-results-browse-link">', escape((23,  noResults.Request.MetroId ? String.Format(Resources.Shared.Search.Strings.NoSearchResults_MetroListLink, metroName) : '' )), '</a></div><div> <a href="/" class="link">', escape((23,  String.Format(Resources.Shared.Search.Strings.NoSearchResults_MetroLink, metroName) )), '</a></div><p class="no-result-message italic"> ', escape((23,  Resources.Shared.Redesign.NoResults.OtherSuggestionsMessage )), '</p></div> ');23; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._NoResults'}
,"_NoResultsFreeText":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var noResults = locals.noResults ; buf.push(' <span class="freetext-noresults-term">', escape((1,  noResults.Request.Term )), '</span>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._NoResultsFreeText'}
,"_Pagination":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var pagination = locals.pagination ; buf.push(' ');1; var showPageNumbers = locals.showPageNumbers ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var previousLink=(pagination.PaginationLinks ==null) ? '#' : (!String.IsNullOrEmpty(pagination.PaginationLinks.Previous)) ? pagination.PaginationLinks.Previous : '' ; buf.push(' ');1; var nextLink=(pagination.PaginationLinks ==null) ? '#' : (!String.IsNullOrEmpty(pagination.PaginationLinks.Next)) ? pagination.PaginationLinks.Next : '' ; buf.push('<div class="pagination-container"><ul id="results-pagination" class="pagination pagination-border"><li class="pagination-li pagination-arrow pagination-arrow-prev pagination-border-arrow-prev"> ');1; if (!String.IsNullOrEmpty(previousLink)) { ; buf.push(' <a href="', escape((1,  (previousLink) )), '" class="pagination-link pagination-prev"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Previous )), '</span></a> ');1;} else {; buf.push(' <span class="pagination-link pagination-prev pagination-unavailable"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Previous )), '</span></span> ');1; } ; buf.push('</li> ');1; if (showPageNumbers && pagination.PaginationIndex.Pages && pagination.PaginationIndex.Pages.length > 0) { ; buf.push(' ');1; pagination.PaginationIndex.Pages.forEach(function(page, pageIndex) { ; buf.push('<li class="pagination-li"> <span class="js-pagination-page ', escape((1,  ( page.From != -1 ? 'pagination-link' : '') )), ' ', escape((1,  ( page.From == -1 ? 'pagination-spacer' : '') )), ' ', escape((1,  ( page.IsCurrent ? 'pagination-current' : '') )), '" data-from="', escape((1,  (page.From) )), '"><span class="underline-hover">', (1,  page.Name ), '</span></span></li> ');1; }) ; buf.push(' ');1; } ; buf.push('<li class="pagination-li pagination-arrow pagination-arrow-next pagination-border-arrow-next"> ');1; if (!String.IsNullOrEmpty(nextLink)) { ; buf.push(' <a href="', escape((1,  (nextLink) )), '" class="pagination-link pagination-next"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Next )), '</span></a> ');1;} else {; buf.push(' <span class="pagination-link pagination-next pagination-unavailable"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Next )), '</span></span> ');1; } ; buf.push('</li></ul></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Pagination'}
,"_PopTable":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var popTable = locals.popTable ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var experiments = popTable.Experiments ; buf.push(' ');1; var isMyListsView = !!(popTable.MyListsOptions && popTable.MyListsOptions.Name); ; buf.push(' ');1; var aboutPopURL = 'https://community.opentable.com/t5/FAQs-Knowledge-Base/What-are-OpenTable-points/ta-p/109' 
; buf.push(' ');1; var redesignExperimentActive = experiments.sv1787 || experiments.sv2046 ; buf.push(' ');1; var popTableSelector = redesignExperimentActive ? 'pop-block' : 'poptable-results' ; buf.push(' ');1; var totalPop = experiments.sv2046 ? popTable.Results.TotalPopAvailable.toLocaleString() : popTable.Results.TotalPopAvailable ; buf.push(' ');1; if (popTable.Results.FeaturedPopRestaurants.length > 0 && (popTable.Request.OnlyPopTimes == null || popTable.Request.OnlyPopTimes == false) && (popTable.Request.OnlyUnavailable != true) && (isMyListsView == false)) { ; buf.push('<section id="', escape((1,  popTableSelector )), '" class="', escape((1,  popTableSelector )), ' content-block with-margin"><div class="', (1,  redesignExperimentActive ? 'flex-row-justify pop-header' : 'content-block-header with-border' ), '"><div class="pop-header-block"><h6 class="pop-title"> ', escape((1,  Resources.Shared.Common.Results.FeaturedPointsTitle )), '</h6> <a href="', (1,  aboutPopURL ), '" class="pop-about-link" target="_blank">', escape((1,  redesignExperimentActive ? '?' : Resources.Shared.Redesign.Results.AboutBonusPointRestaurants )), '</a></div> ');1; if (redesignExperimentActive && popTable.Results.TotalPopAvailable > 3) { ; buf.push(' <a id="pop_see_all_link" class="text-arrow-right" target="_blank"><span class="underline-hover">', escape((1,  String.Format(Resources.Shared.Common.Results.SeeAllPopLink, totalPop) )), '</span></a> ');1; } ; buf.push('</div><div class="pop-result-grid"> ');1; popTable.Results.FeaturedPopRestaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (1,  partial('Redesign/Results/_Result', {
          restaurant: restaurant,
          resultViewModel: popTable,
          onlyPopTimes: true,
          showImages: false,
          restaurantIndex: restaurantIndex,
          showPop: popTable.Display.ShowPop,
          isPopTableResult: true
        }) ), ' ');9; }) ; buf.push('</div> ');9; if (popTable.Results.TotalPopAvailable > popTable.Results.FeaturedPopRestaurants.length && !redesignExperimentActive) { ; buf.push('<div class="content-block-footer"> <a id="pop_see_all_link" class="text-arrow-right"><span class="underline-hover">', escape((9,  String.Format(Resources.Shared.Common.Results.SeeAllPopRestaurants, popTable.Results.TotalPopAvailable) )), '</span></a></div> ');9; } ; buf.push('</section> ');9; if (redesignExperimentActive) { ; buf.push('<div class="all-restaurants-results-header"> ', escape((9,  String.Format(Resources.Shared.Common.Results.AllRestaurantsHeader) )), '</div> ');9; } ; buf.push(' ');9; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._PopTable'}
,"_Pricing":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var price = locals.price ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var experiments = locals.experiments ; buf.push('<div class="rest-row-pricing', escape((1,  experiments.sv2046 ? ' rest-row-meta-text' : '' )), '"><i', escape((1,  experiments.sv2046 ? ' class="bold-info-text"' : '' )), '>');1; [1,2,3,4].forEach(function(i, iIndex) { ; buf.push(' ');1; if (i <= price) { ; buf.push(' ', escape((1,  Resources.Shared.Redesign.Strings.CurrencySymbol )), ' ');1; } ; buf.push(' ');1; }) ; buf.push('</i> ');1; [1,2,3,4].forEach(function(i, iIndex) { ; buf.push(' ');1; if (i <= 4 - price) { ; buf.push(' ', escape((1,  Resources.Shared.Redesign.Strings.CurrencySymbol )), ' ');1; } ; buf.push(' ');1; }) ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Pricing'}
,"_RequestBooking":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var requestBooking = locals.requestBooking ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="rest-row-times-cont"> <a href="', escape((1,  requestBooking.ProfileUri )), '" class="button small request-button">', escape((1,  Resources.Shared.Redesign.Results.RequestReservation )), '</a></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._RequestBooking'}
,"_RestaurantPromo":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var searchViewModelPromo = locals.searchViewModelPromo ; buf.push(' ');1; var restaurantPromo = locals.restaurantPromo ; buf.push(' ');1; var restaurantViewModelPromo = locals.restaurantViewModelPromo ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push('<div class="rest-row-promo-wrapper"> ');1; if (!String.IsNullOrEmpty(restaurantPromo.Message)) { ; buf.push('<div class="rest-promo-message"> ', (1,  (restaurantPromo.Message) ), '</div> ');1; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._RestaurantPromo'}
,"_Result":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var restaurant = locals.restaurant ; buf.push(' ');1; var reviews = locals.restaurant.Reviews ; buf.push(' ');1; var experiments = locals.Experiments || {} ; buf.push(' ');1; var resultViewModel = locals.resultViewModel ; buf.push(' ');1; var onlyPopTimes = locals.onlyPopTimes ; buf.push(' ');1; var showImages = locals.showImages ; buf.push(' ');1; var Request = locals.Request || resultViewModel.Request ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var restaurantIndex = locals.restaurantIndex ; buf.push(' ');1; var showPop = locals.showPop ; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var milesToDisplay = locals.helpers.milesToDisplay ; buf.push(' ');1; var listIndex = restaurantIndex + 1 ; buf.push(' ');1; var missingRestImage = experiments.sv1375 ? "/s/static/images/no-image-sv1375.png" : "/s/static/images/no-image.png" ; buf.push(' ');1; var mapsExperimentOn = experiments.sv912 === 2 || experiments.sv912 === 3 ; buf.push(' ');1; var slidingTimeslotsOn = experiments.sv1371 ? '1371' : '' ; buf.push(' ');1; var dinersChoiceBaseCheck = restaurant.Reviews.Awards && restaurant.Reviews.Awards.length && !isPopTableResult && resultViewModel.Request.PageType === 0 ; buf.push(' ');1; var freeTextBaseCheck = !isPopTableResult && Request && Request.Term && restaurant.FreeText ; buf.push(' ');1; var contextType =  Resources.Shared.Search.FreeTextSearch ; buf.push(' ');1; var NEWLY_ADDED_RESTAURANTS_PAGE =  resultViewModel.Request.PageType === 5 ; buf.push(' ');1; var redesignExperimentActive = resultViewModel.Experiments.sv1787 || resultViewModel.Experiments.sv2046 ; buf.push(' ');1; var campaignId = resultViewModel.Results.CampaignIds ? resultViewModel.Results.CampaignIds[restaurant.Id] : null ; buf.push(' ');1; var isPromoted = campaignId && !restaurant.HasPop && !restaurant.HasOffers && !isPopTableResult ; buf.push(' ');1; var showDistance = Request.IsGeoDistanceRequest ; buf.push(' ');1; var isRedesignTest = resultViewModel.Experiments.sv2046 || resultViewModel.Experiments.sv2393 ; buf.push(' ');1;
var lookup = {
  menu: 'Menu',
  description: 'Description',
  reviews: 'Reviews'
};
var cuisineName = restaurant.Cuisine;
var cuisineNameStripped = cuisineName;
if (restaurant.Cuisines && restaurant.Cuisines.length && resultViewModel.Experiments.sv1793)  {
  // isContinentalId checks to see if the first cuisine is 'Continental'.
  // We are currently not using this and it does not maintain functionality for this test.
  // If the first cuisine is this, then the second cuisine returned is used.
  var isContinentalId = restaurant.Cuisines[0].id === 'd3b021a0-9d32-4882-876e-e5546074524b' ? 1 : 0;
  cuisineName = restaurant.Cuisines[isContinentalId].name;

  if (freeTextBaseCheck && restaurant.FreeText.Matches.Cuisines && restaurant.FreeText.Matches.Cuisines[0]) {
    cuisineName = restaurant.FreeText.Matches.Cuisines[0];
  }
  cuisineNameStripped = cuisineName.replace(/[>/<]|(strong)/g, '');

  function getUrlSegement(ids, type) {
    return ids ? ids.map(function(elem) {
      return '&' + type + '%5B%5D=' + elem;
    }).join('') : '';
  }

  function getNeighboorHoodsUrlSegment(NeighborhoodIds) {
    return NeighborhoodIds ? NeighborhoodIds.map(function(elem) {
      return '&neighborhoodids%5B%5D=' + elem;
    }).join('') : '';
  }

  var neighborhoods = getUrlSegement(Request.ParsedNeighborhoodIds, 'neighborhoodids');
  var tags = getUrlSegement(Request.TagIds, 'tagids');
  var prices = Request.PriceBandIds ? getUrlSegement(Request.PriceBandIds.split(','), 'pricebandids') : '';

  var cuisineHref = '/s/?currentview=' + Request.CurrentView +
  '&showmap=' + Request.ShowMap +
  '&size=' + Request.Size +
  '&sort=' + Request.Sort +
  '&covers=' + Request.Covers +
  '&dateTime=' + Request.DateTime.replace(' ', '+').replace(':', '%3A') +
  '&metroId=' + Request.MetroId +
  (Request.RegionIds ? '&regionIds=' + Request.RegionIds : '') +
  '&lang=' + resultViewModel.DomainCulture.Language +
  '&onlyexactdatetime=' + Request.OnlyExactDateTime +
  '&onlypoptimes=' + Request.OnlyPopTimes +
  '&onlyoffers=' + Request.OnlyOffers +
  neighborhoods + tags + prices +
  '&term=' + cuisineNameStripped;
} ; buf.push(' ');51;
  var bodyCssClasses = ["result", "content-section-list-row", "cf"];

  if (resultViewModel.Display.ShowTimeSlotsInResults) {
    bodyCssClasses.push("with-times");
  }
; buf.push(' ');57; var timeslots = resultViewModel.Display.ShowTimeSlotsInResults ? partial('Redesign/Results/_Timeslots', {
  timeslots: restaurant,
  timeSlotsRequest: resultViewModel.Request,
  notAvailableButtonClass: '',
  displayOnlyPopTimes: onlyPopTimes,
  showPopTimes: showPop,
  Model: resultViewModel,
  partial: partial,
  isPopTableResult: isPopTableResult
}) : '' ; buf.push('<div class="', escape((66,  bodyCssClasses.join(' ') )), '" data-id="', escape((66,  restaurantIndex )), '" data-rid="', escape((66,  restaurant.Id )), '" data-offers="', escape((66,  String.Join(',', restaurant.OfferIds) )), '" data-lat="', escape((66,  restaurant.Lat )), '" data-lon="', escape((66,  restaurant.Lon )), '" data-index="', escape((66,  listIndex )), '" ');66; if (resultViewModel.Experiments.sv1371) { ; buf.push(' data-timeslots="', (66,  restaurant.TimeSlots.length ), '" ');66; } ; buf.push('><div class="rest-row with-image"> ');66; if (showImages || redesignExperimentActive && isPopTableResult) { ; buf.push('<div class="rest-row-image"> <a href="', escape((66,  restaurant.ProfileUri )), '" target="_blank" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((66, restaurant.Id)), ')"><img src="', escape((66,  missingRestImage )), '" ');66; var imageSize = redesignExperimentActive && isPopTableResult ? 'medium' : 'legacy' ; buf.push(' data-src="//resizer.otstatic.com/v2/profiles/', escape((66,  imageSize )), '/', escape((66,  restaurant.Id )), '.jpg" alt="', escape((66,  String.Format(Resources.Shared.Search.Results.AltTag, restaurant.Name).toLowerCase() )), '" class="lazy rest-image"/></a></div> ');66; } ; buf.push('<div class="rest-row-info"><div class="rest-row-header', escape((66,  isPromoted ? ' flex-row-justify' : '' )), '"> <a href="', escape((66,  restaurant.ProfileUri )), '" class="rest-row-name rest-name ', escape((66,  restaurant.IsJustAdded ? 'just-added' : '' )), '" target="_blank" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((66, restaurant.Id)), ')">');66; if (listIndex && mapsExperimentOn) { ; buf.push(' <span class="list-index">', escape((66,  listIndex )), '.</span> ');66; } ; buf.push(' <span class="rest-row-name-text">', (66,  (freeTextBaseCheck && restaurant.FreeText.Matches.Name && restaurant.FreeText.Matches.Name[0]) || restaurant.Name ), '</span> ');66; if (restaurant.IsJustAdded && !NEWLY_ADDED_RESTAURANTS_PAGE) { ; buf.push(' <span class="new-restaurant-tag">', (66,  Resources.Shared.Common.Results.JustAdded_New ), '</span> ');66; } ; buf.push(' ');66; if (dinersChoiceBaseCheck) { ; buf.push('<span class="diners-choice-badge"><span class="trophy-icon"></span> <span class="diners-choice-kind">', escape((66,  restaurant.Reviews.Awards[0].Name )), '</span></span> ');66; } ; buf.push('</a> ');66; if (isPromoted) { ; buf.push(' <span class="promoted-badge">', escape((66,  Resources.Shared.Common.Results.Promoted )), '</span> ');66; } ; buf.push('</div> ');66; if (isPopTableResult) { ; buf.push('<div class="flex-row-justify"> ', (66,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            reviews: reviews,
            size: 'small',
            url: restaurant.ProfileUri + '#reviews'
            }) ), ' ');72; if (resultViewModel.Display.ShowPrices && (!isRedesignTest || isPopTableResult)) { ; buf.push(' ', (72,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
              }) ), ' ');75; } ; buf.push('</div><div class="rest-row-meta rest-row-meta-grid"> ');75; if (resultViewModel.Display.ShowPrices && !showDistance && (isRedesignTest && !isPopTableResult)) { ; buf.push(' ', (75,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
              }) ), ' ');78; } ; buf.push(' ');78; if (restaurant.Cuisines && resultViewModel.Experiments.sv1793)  { ; buf.push(' <a class="rest-row-meta--cuisine rest-row-meta-text" href="', (78,  cuisineHref ), '" target="_blank">', (78,  cuisineName ), '</a> ');78; } else if (restaurant.Cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (78,  cuisineName ), '</span> ');78; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', (78,  restaurant.Location ), '</span></div> ');78; } else if (!showDistance) { ; buf.push('<div class="', escape((78,  isRedesignTest ? '' : ' flex-row-justify')), '"> ', (78,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            reviews: reviews,
            size: 'small',
            url: restaurant.ProfileUri + '#reviews'
            }) ), ' ');84; if (resultViewModel.Display.ShowPrices && !isRedesignTest) { ; buf.push(' ', (84,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
              }) ), ' ');87; } ; buf.push('</div><div class="rest-row-meta rest-row-meta-grid', escape((87,  isRedesignTest ? '' : ' flex-row-justify')), '"> ');87; if (resultViewModel.Display.ShowPrices && isRedesignTest) { ; buf.push(' ', (87,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
              }) ), ' ');90; } ; buf.push(' ');90; if (restaurant.Cuisines && resultViewModel.Experiments.sv1793)  { ; buf.push(' <a class="rest-row-meta--cuisine rest-row-meta-text" href="', (90,  cuisineHref ), '" target="_blank">', (90,  cuisineName ), '</a> ');90; } else if (restaurant.Cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (90,  cuisineName ), '</span> ');90; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', escape((90,  restaurant.Location )), '</span></div> ');90; } else { ; buf.push('<div', (90,  showDistance ? ' class="rest-row-info--essentials"' : '' ), '><div class="rest-row-info--group"> ', (90,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            reviews: reviews,
            size: 'small',
            url: restaurant.ProfileUri + '#reviews'
            }) ), '<div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--type"> ');96; if (resultViewModel.Display.ShowPrices && showDistance && isRedesignTest) { ; buf.push(' ', (96,  partial('Redesign/Results/_Pricing', {
                  price: restaurant.PriceBand.Id,
                  experiments: resultViewModel.Experiments
                  }) ), ' ');99; } ; buf.push(' ');99; if (resultViewModel.Display.ShowPrices && showDistance) { ; buf.push(' ', (99,  partial('Redesign/Results/_Pricing', {
                  price: restaurant.PriceBand.Id,
                  experiments: resultViewModel.Experiments
                  }) ), '<span class="rest-row--text-bullet"></span> ');102; } ; buf.push(' ');102; if (restaurant.Cuisines && resultViewModel.Experiments.sv1793)  { ; buf.push(' <a class="rest-row-meta--cuisine rest-row-meta-text" href="', escape((102,  cuisineHref )), '" target="_blank">', escape((102,  cuisineName )), '</a> ');102; } else if (restaurant.Cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (102,  cuisineName ), '</span> ');102; } ; buf.push(' ');102; if (resultViewModel.Display.ShowPrices && !showDistance && !isRedesignTest) { ; buf.push(' ', (102,  partial('Redesign/Results/_Pricing', {
                  price: restaurant.PriceBand.Id,
                  experiments: resultViewModel.Experiments
                  }) ), ' ');105; } ; buf.push('</div></div><div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--distance"> <span class="rest-row-meta--location rest-row-meta-text">', escape((105,  restaurant.Location )), '</span><span class="rest-row-meta--distance rest-row-meta-text"><span class="distance-icon"></span> ', escape((105,  milesToDisplay(restaurant.Distance, Resources.Strings.DistanceUnit_Small) )), ' ', escape((105,  Resources.Strings.DistanceUnit_Small )), '</span></div></div> ');105; } ; buf.push(' ');105; if (restaurant.IsListingsRestaurant && !redesignExperimentActive) { ; buf.push('<div class="listings-message"> ', escape((105,  Resources.Shared.Redesign.Results.ListingsMessage )), '</div> ');105; } else { ; buf.push(' ');105; if (resultViewModel.Display.ShowTimeSlotsInResults && restaurant.HandlesRequestBookings) { ; buf.push(' ', (105,  partial('Redesign/Results/_RequestBooking', {
            requestBooking: restaurant
          }) ), ' ');107; } else if (!isPopTableResult || redesignExperimentActive) { ; buf.push(' ', (107,  timeslots ), ' ');107; } ; buf.push(' ');107; } ; buf.push(' ');107; if (freeTextBaseCheck && lookup[restaurant.FreeText.SingleRelevanceSource]) { ; buf.push(' ', (107,  partial('Redesign/Results/_FreeTextBlurb', {
          freeTextBaseCheck: freeTextBaseCheck,
          lookup: lookup,
          restaurant: restaurant
        }) ), ' ');111; } ; buf.push(' ');111; if (resultViewModel.Display.ShowOffers && restaurant.TopOffer != null) { ; buf.push('<div class="rest-row-offer" data-id="', escape((111,  (restaurant.TopOffer.Id) )), '"><p> ', escape((111,  Resources.Shared.Redesign.Strings.Label_TopOffer )), ' <a href="', escape((111,  restaurant.ProfileUri )), '#special-offers">', escape((111,  restaurant.TopOffer.Name )), '</a></p> ');111; if (restaurant.OfferIds.length > 1) { ; buf.push('<p class="rest-row-offer-link"> ', escape((111,  Resources.Shared.Common.Results.SeeAllOffers )), '</p> ');111; } ; buf.push('</div> ');111; } ; buf.push('</div></div> ');111; if (isPopTableResult && !redesignExperimentActive) { ; buf.push(' ', (111,  timeslots ), ' ');111; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Result'}
,"_ResultsTable":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsTable = locals.resultsTable ; buf.push(' ');1; var experiments = resultsTable.Experiments.enums ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = locals.Html ; buf.push(' ');1; var isMyListsView = locals.isMyListsView ; buf.push(' ');1; var showAdvert = locals.showAdvert ; buf.push(' ');1; var queryParams = locals.queryParams ; buf.push(' ');1; var showDistance = locals.showDistance ; buf.push(' ');1; if (locals.helpers.hasAddonRestaurants(resultsTable)) { ; buf.push('<div class="content-section-header ', escape((1,  resultsTable.Experiments.sv2137 ? 'exact-header' : 'flex-row-justify' )), '"> ');1; if(resultsTable.Experiments.rush1574) { ; buf.push(' ');1; var singleSearchedRestaurant = resultsTable.Results.AddonsRestaurant.Restaurants[0] ; buf.push('<h3 class="results-title color-dark single-search-result"> ', (1,  String.Format(Resources.Shared.Redesign.Results.SingleSearchResults, singleSearchedRestaurant.Name) ), '</h3> ');1; } else if (!resultsTable.Experiments.sv2137) { ; buf.push('<h3 class="results-title color-dark"> ', (1,  Resources.Shared.Redesign.Results.Title_Exact_Match ), '</h3> ');1; } ; buf.push('<div class="sort-view-filters"><div id="sort-filters" class="filter-option filter-option-sort-orders"> ', (1,  partial('Redesign/Filters/_FilterSortOrder', {
          request: resultsTable.Request,
          experiments: resultsTable.Experiments,
          showDistance: showDistance
        }) ), '</div> ');5; if (!resultsTable.Request.Term) { ; buf.push('<div class="search-tab view-toggle"> ', (5,  partial('Redesign/Filters/_FilterViewOptions', {
            filterViewOptions: resultsTable
          }) ), '</div> ');7; } ; buf.push('</div></div><div class="content-section-list infinite-results-list exact-match"> ');7; resultsTable.Results.AddonsRestaurant.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ');7; if (resultsTable.Experiments.sv2137) { ; buf.push('<div class="exact-title"> ');7; var recommend = restaurant.Reviews.Recommended;
            var percentRecommend = Math.floor(recommend.Yes/recommend.Count * 100) || 0; ; buf.push(' ');8; if (percentRecommend >= 75) { ; buf.push(' ', escape((8,  String.Format(Resources.Strings.ExactMatch_Recommend, percentRecommend) )), ' ');8; } else { ; buf.push(' ', escape((8,  Resources.Strings.ExactMatch_Urgency )), ' ');8; } ; buf.push('</div> ');8; } ; buf.push(' ', (8,  partial('Redesign/Results/_Result', {
          Experiments: resultsTable.Experiments,
          restaurant: restaurant,
          resultViewModel: resultsTable,
          onlyPopTimes: !!resultsTable.Request.OnlyPopTimes,
          showImages: true,
          restaurantIndex: restaurantIndex,
          showPop: resultsTable.Display.ShowPop,
          isPopTableResult: false,
          showDistance: showDistance
        }) ), ' ');18; }) ; buf.push('</div> ');18; } ; buf.push('<div class="content-section-header"> ');18; if (!String.IsNullOrEmpty(resultsTable.Display.Description)) { ; buf.push('<div id="page-description" class="page-description"> ', (18,  (resultsTable.Display.Description) ), '</div> ');18; } ; buf.push(' ', (18,  partial('Redesign/Results/_ResultsTitle', {
    resultsTitle: resultsTable,
    helpers: locals.helpers
  }) ), '</div> ');21; if (resultsTable.Display.ShowPop && resultsTable.Results.TotalPop && !resultsTable.Request.Term) { ; buf.push('<div id="search_results_pop" class="results-set results-table pop-table" data-name="PopTable"> ', (21,  partial('Redesign/Results/_PopTable', {
        popTable: resultsTable
      }) ), '</div> ');23; } ; buf.push(' ');23; if (resultsTable.Results && resultsTable.Results.Restaurants && resultsTable.Results.Restaurants.length > 0) { ; buf.push('<div class="content-section-list infinite-results-list"> ');23; resultsTable.Results.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (23,  partial('Redesign/Results/_Result', {
            Experiments: resultsTable.Experiments,
            Request: resultsTable.Request,
            restaurant: restaurant,
            resultViewModel: resultsTable,
            onlyPopTimes: !!resultsTable.Request.OnlyPopTimes,
            showImages: true,
            restaurantIndex: restaurantIndex,
            showPop: resultsTable.Display.ShowPop,
            isPopTableResult: false,
            showDistance: showDistance
        }) ), ' ');34; }) ; buf.push('</div> ');34; if (resultsTable.Experiments.sv1181 && (resultsTable.Request.Size || resultsTable.Request.Limit) <= 10) { ; buf.push('<div id="loading-animation-row"><div class="spinner"></div></div> ');34; } ; buf.push(' ');34; } ; buf.push(' ');34; if (resultsTable.Display.ShowPagination) { ; buf.push(' ', (34,  partial('Redesign/Results/_Pagination', {
    pagination: resultsTable.Display,
    showPageNumbers: true
  }) ), ' ');37; } ; buf.push(' ', (37,  partial('Redesign/Results/_AvailabilityLink', {
  availabilityLink: resultsTable
}) ), ' ');39; if (!String.IsNullOrEmpty(resultsTable.Display.AdditionalDetails)) { ; buf.push('<div class="promo-more-details"> ', (39,  resultsTable.Display.AdditionalDetails ), '</div> ');39; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ResultsTable'}
,"_ResultsTitle":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsTitle = locals.resultsTitle;
var AdvertType = locals.AdvertType;
var Html = !!locals.Html ? locals.Html : window.Html;
var Model = locals.Model;
var PageType = locals.PageType;
var Request = locals.Request;
var Resources = !!locals.Resources ? locals.Resources : window.Resources;
var SrsPageType = locals.SrsPageType;
var System = locals.System;
var block = locals.block;
var layout = locals.layout;
var partial = locals.partial;
var hasAddonRestaurants = locals.helpers.hasAddonRestaurants(resultsTitle);
; buf.push('<div class="flex-row-justify"> ');14; if (hasAddonRestaurants && resultsTitle.Experiments.rush1574) { ; buf.push('<h3 class="results-title single-search-result"> ', (14,  Resources.Shared.Redesign.Results.RestaurantsYouMayLike ), '</h3> ');14; } else if (hasAddonRestaurants && resultsTitle.Experiments.sv2137 && resultsTitle.Display.CurrentView === 'list') { ; buf.push('<h3 class="results-title single-search-result"> ', escape((14,  Resources.Strings.NearbyRestaurants )), '</h3> ');14; } else { ; buf.push(' ');14; if (!String.IsNullOrEmpty(resultsTitle.Request.Title)) { ; buf.push('<h2>', escape((14,  resultsTitle.Request.Title )), '</h2> ');14; } ; buf.push('<h3 id="results-title" class="results-title color-dark"> ');14; if (resultsTitle.IsPromo) { ; buf.push(' ');14; if (resultsTitle.Results.TotalAvailable == 1) { ; buf.push(' ');14; var searchTitle=Resources.Shared.Redesign.Results.Title_Promos ; buf.push(' ', escape((14,  String.Format(searchTitle, resultsTitle.Results.TotalAvailable) )), ' <span class="result-promo-title">', escape((14,  resultsTitle.Display.ResultsTitle )), '</span> ');14;} else {; buf.push(' ');14; var searchTitle=Resources.Shared.Redesign.Results.Title_Promos_Plural ; buf.push(' ', escape((14,  String.Format(searchTitle, resultsTitle.Results.TotalAvailable) )), ' <span class="result-promo-title">', escape((14,  resultsTitle.Display.ResultsTitle )), '</span> ');14; } ; buf.push(' ');14;} else {; buf.push(' ', escape((14,  resultsTitle.Display.ResultsTitle )), ' ');14; } ; buf.push('</h3> ');14; } ; buf.push(' ');14; if (!hasAddonRestaurants || resultsTitle.Display.CurrentView === 'map') { ; buf.push('<div class="sort-view-filters"><div id="sort-filters" class="filter-option right filter-option-sort-orders"> ', (14,  partial('Redesign/Filters/_FilterSortOrder', {
          request: resultsTitle.Request,
          experiments: resultsTitle.Experiments
        }) ), '</div> ');17; if (!resultsTitle.Experiments.sv2046) { ; buf.push('<div class="search-tab right view-toggle"> ', (17,  partial('Redesign/Filters/_FilterViewOptions', {
            filterViewOptions: resultsTitle
          }) ), '</div> ');19; } ; buf.push('</div> ');19; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ResultsTitle'}
,"_Reviews":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var reviews = locals.reviews ; buf.push(' ');1; var url = locals.url ; buf.push(' ');1; var experiments = locals.Experiments ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var resourceResults = Resources.Shared.Redesign.Results ; buf.push(' ');1; var isRedesignTest = experiments.sv2046 || experiments.sv2393 ; buf.push(' ');1; var total = isRedesignTest ? '<span class="bold-info-text">' + reviews.Total.toLocaleString() + '</span>' : reviews.Total ; buf.push(' ');1; var reviewText = String.Format(reviews.Total === 1 ? resourceResults.Reviews : resourceResults.Reviews_Plural, total) ; buf.push(' ');1; var showRatings = reviews && reviews.Total > 0 && reviews.ShowReviews ; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push('<div class="rest-row-review"> ');1; if (showRatings) { ; buf.push(' ');1; var reviewRating = reviews.Rating ; buf.push(' ');1; var starTitle = String.Format(reviewRating == 1 ? Resources.Strings.StarRatingText : Resources.Strings.StarRatingText_Plural, reviewRating) ; buf.push('<div class="star-rating review-container"><div class="star-wrapper small"><div class="all-stars"></div><div class="all-stars filled" style="width: ', escape((1,  reviewRating * 20 )), '%;"></div></div> <a class="review-link" href="', (1,  url ), '" target="_blank">');1; if (isRedesignTest) { ; buf.push(' <span class="star-rating-text underline-hover">', (1,  total ), '</span> <span class="star-rating-text--review-text underline-hover">', (1,  reviewText ), '</span> ');1; } else { ; buf.push(' <span class="star-rating-text underline-hover">(', escape((1,  total )), ')</span> <span class="star-rating-text--review-text underline-hover">', escape((1,  reviewText )), '</span> ');1; } ; buf.push('</a></div> ');1; } else { ; buf.push('<div class="review-container"> ', escape((1,  Resources.Shared.Redesign.Results.ReviewsComingSoon )), '</div> ');1; }
  if (!isPopTableResult && reviews.Recommended && reviews.Recommended.Count) {
    var recommend = reviews.Recommended;
    var percentRecommend = Math.floor(recommend.Yes/recommend.Count * 100) || 0;
    var showRecommended = percentRecommend > 70 || (recommend.Count && recommend.Count >= 10);
    percentRecommend += '%';
    percentRecommend = isRedesignTest ? '<span class="bold-info-text">' + percentRecommend + '</span>' : percentRecommend;
    if (showRecommended) { ; buf.push(' <span class="recommended-container">');8; if (isRedesignTest) { ; buf.push(' <span class="recommended-small">', (8,  percentRecommend ), '</span> <span class="recommended-text">', (8,  String.Format(Resources.Strings.Recommended, percentRecommend) ), '</span> ');8; } else { ; buf.push('<span class="thumbs-up-icon"></span> <span class="recommended-small">', escape((8,  percentRecommend )), '</span> <span class="recommended-text">', escape((8,  String.Format(Resources.Strings.Recommended, percentRecommend) )), '</span> ');8; } ; buf.push('</span> ');8; }
  } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Reviews'}
,"_SingleSearchReserveLink":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var searchViewModel = locals.searchViewModel ; buf.push(' ');1; var restaurantViewModel = locals.restaurantViewModel ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; if (searchViewModel  &&
    searchViewModel.IsPromo &&
    restaurantViewModel &&
    restaurantViewModel.Promo) { ; buf.push(' ', (4,  partial('Redesign/Results/_RestaurantPromo', {
    searchViewModelPromo: searchViewModel.Promo,
    restaurantPromo: restaurantViewModel.Promo,
    restaurantViewModelPromo: restaurantViewModel
  }) ), ' ');8;} else if (!searchViewModel.Request.IsAvailabilityRequest) { ; buf.push('<div class="rest-row-reserve-button"> <a class="reserve-link button medium" data-profile-url="', escape((8,  (restaurantViewModel.ProfileUri) )), '">', escape((8,  (Resources.Shared.Redesign.Strings.Reserve_Now) )), '</a></div> ');8; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._SingleSearchReserveLink'}
,"_TimeslotAvailability":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var timeslotsLeft = locals.timeslotsLeft ; buf.push(' ');1; var experiments = locals.experiments ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; if (timeslotsLeft < 5 && timeslotsLeft) { ; buf.push(' ');1; var timeslotString = experiments.sv2393 ? '<span class="bold-info-text">' + timeslotsLeft + '</span>' : timeslotsLeft ; buf.push(' ');1; var timeslot = Resources.Shared.Redesign.Strings.TimeslotAvailability_Single ; buf.push(' ');1; var timeslots = String.Format(Resources.Shared.Redesign.Strings.TimeslotAvailability_Multiple, timeslotString) ; buf.push(' ');1; var message = timeslotsLeft === 1 ? timeslot : timeslots ; buf.push('<div class="notice-timeslot"><span class="clock-icon"></span> <span>', (1,  message ), '</span></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._TimeslotAvailability'}
,"_Timeslots":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var timeslots = locals.timeslots ; buf.push(' ');1; var timeSlotsRequest = locals.timeSlotsRequest ; buf.push(' ');1; var displayOnlyPopTimes = locals.displayOnlyPopTimes ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var experiments = Model.Experiments.enums ; buf.push(' ');1; var OnlyExactDateTime = Model.Request.OnlyExactDateTime ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var showPopTimes = locals.showPopTimes ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push(' ');1; var timeslotsLeft = timeslots.TimeSlots.filter(function(el) {
  return el.IsAvail;}).length; ; buf.push(' ');2; var isMobile = Model.UserAgent.indexOf(/(tablet|touch|Android|Pixel|iPad|iPhone)/g) !== -1 ; buf.push(' ');2; var slidingAvailability = timeslots.TimeSlots.length > 5 ; buf.push(' ');2; var hasSliding = slidingAvailability && Model.Experiments.sv1371 && !isMobile && !isPopTableResult ; buf.push(' ');2; var giftParams = Model.giftParams ; buf.push(' ');2;
  var exactIndex = 2;
  var translatePercent = 0;
  if (hasSliding) {
    for (var i = exactIndex; i < timeslots.TimeSlots.length - 2; i++) {
      if (timeslots.TimeSlots[i].ExactCenter) {
        exactIndex = i;
        translatePercent = (exactIndex-2)*-20;
        break;
      }
    }
  }
  var fadeLeftArrow = exactIndex === 2;
  var fadeRightArrow = timeslots.TimeSlots.length === exactIndex + 3;
; buf.push(' ');16; if (!isPopTableResult) { ; buf.push('<div class="message-alerts"> ');16; if (!OnlyExactDateTime && timeslots.TimeSlotsComplete) { ; buf.push(' ', (16,  partial('Redesign/Results/_TimeslotAvailability', {
      timeslotsLeft: timeslotsLeft,
      Resources: Resources,
      partial: partial,
      experiments: Model.Experiments
    }) ), ' ');21; } ; buf.push('</div> ');21; } ; buf.push(' ');21; if ((isPopTableResult && slidingAvailability && Model.Experiments.sv1371) || isMobile) {
  timeslots.TimeSlots = timeslots.TimeSlots.slice(exactIndex - 2, exactIndex + 3);
  }
; buf.push(' ');24; if (timeslots.HasAvail) { ; buf.push(' ');24;
    var showBonusPointsLegend = false;
    var restaurantHasOffers = false;
    var restRowTimesContainerClass = ['rest-row-times-cont'];

    if (Model.Display.ShowOffers) {
      timeslots.TimeSlots.forEach(function (timeSlot) {
        if (timeSlot.IsAvail && timeSlot.OfferIds && timeSlot.OfferIds.length > 0) {
          restaurantHasOffers = true;
        }
      });
    }

    if (restaurantHasOffers) {
      restRowTimesContainerClass.push('has-offers');
    }
  ; buf.push('<div class="', escape((40,  restRowTimesContainerClass.join(' ') )), '"><div class="rest-row-times"> ');40; if (hasSliding) { ; buf.push('<div class="arrow-left slide-arrow', (40,  fadeLeftArrow ? ' faded-arrow' : '' ), '"></div> ');40; } ; buf.push('<div class="timeslot-window"><ul class="availability-row-container', (40,  slidingAvailability ? ' sliding-row' : '' ), '" ');40; if (hasSliding) { ; buf.push(' style="transform: translateX(', (40,  translatePercent ), '%)" data-center-index="', (40,  exactIndex ), '" data-initial-transform="', (40,  translatePercent ), '" ');40; } ; buf.push('> ');40; timeslots.TimeSlots.forEach(function(timeSlot, timeSlotIndex) { ; buf.push(' ');40;
              var timeslotDisabled = !timeSlot.IsAvail || (displayOnlyPopTimes && !timeSlot.HasPop);
              var isExact = timeSlotIndex == 2;
              var hash = timeSlot.Hash || '';
              var hasPop = timeSlot.HasPop && showPopTimes;
              var hasOffers = Model.Display.ShowOffers && timeSlot.OfferIds != null && timeSlot.OfferIds.length > 0;
              var offerIds = hasOffers ? String.Join(',', timeSlot.OfferIds) : '';
              var offersCount = timeSlot.OfferIds.length + (hasPop ? 1 : 0);
              var isPremium = (timeSlot.Price && timeSlot.Price.Amount > 0);
              var isFakeTimeslotTestOn = Model.Experiments.sv1852 && timeSlot.ShouldDisappear;

              var hasTableCategories = timeSlot.TableCategories
                && timeSlot.TableCategories.length
                && !(timeSlot.TableCategories.indexOf("default") !== -1
                  && timeSlot.TableCategories.length === 1);

              if (hasTableCategories && timeSlot.TimeString.indexOf('*') === -1) {
                timeSlot.TimeString += '*';
              }

              var domainCulture = locals.Model.DomainCulture;
              var cultureUrlSegment = domainCulture.addCultureToPath ?  '/' + domainCulture.Culture : '';
              var pointValue = timeSlot.Points || (hasPop ? 1000 : 100);
              var slotTime = timeSlot.DateTime;

              if (typeof moment != "undefined") {
                slotTime = moment(timeSlot.LinkString).format('HH:mm:ss');
              } else {
                if (typeof slotTime === 'string') {
                  slotTime = timeSlot.DateTime.substring(timeSlot.DateTime.indexOf('T')+1);
                }
              }

              var restRefParam = Model.Request.RestRef ? '&restref=' + timeslots.Id : '';
              var refParam = Model.Request.Ref ? '&ref=' + Model.Request.Ref : '';
              var timeslotFormat = '{6}/book/validate?rid={0}&d={2}&p={1}&pt={5}&ss=0&sd={2}&pofids={3}&hash={4}';

              if (pointValue > 100) {
                timeslotFormat += '&i=1';
              }

              var slotUrl = String.Format(
                timeslotFormat,
                timeslots.Id,
                timeSlotsRequest.Covers,
                timeSlot.LinkString,
                String.Join(",", timeSlot.OfferIds),
                hash,
                pointValue,
                cultureUrlSegment,
                restRefParam,
                refParam
              );

              var timeslotClasses = ['rest-row-times-btn'];

              if (isExact) {
                timeslotClasses.push('exact');
              }

              if (isFakeTimeslotTestOn && typeof process === 'object') {
                timeslotClasses.push('taken timeslot');
              } else if ((typeof process !== 'object' && isFakeTimeslotTestOn) ||  timeslotDisabled || (isPremium && !Model.Display.ShowPremiumAccess)) {
                timeslotClasses.push('unavailable');
              } else {
                timeslotClasses.push('timeslot');
                if (isPremium && Model.Display.ShowPremiumAccess) {
                  timeslotClasses.push('dtp-button-premium');
                }
                if (hasOffers) {
                  timeslotClasses.push('has-offers');
                }
              }

              var timeslotParentClasses = ['timeslot-option'];

              if (timeSlot.IsAvail) {
                timeslotParentClasses.push('timeslot-control');
              }

              if ((isPremium && Model.Display.ShowPremiumAccess) || hasPop || hasOffers) {
                timeslotParentClasses.push('offer-container');

                if (isPremium && Model.Display.ShowPremiumAccess) {
                  timeslotParentClasses.push('dtp-button-premium-wrapper');
                }
              }

              var giftAmount;
              if (timeSlot.LoyaltyRedemption && giftParams) {
                var restaurantRewards = Model.Results.PointRedemptionRewards[timeslots.CountryCode];
                if (restaurantRewards) {
                  var timeSlotTier = restaurantRewards[timeSlot.LoyaltyRedemption];
                  if (timeSlotTier) {
                    giftAmount = timeSlotTier.Levels[giftParams.giftAmount]
                  }
                }
              }

              var instantEligible = timeSlot.instantEligible;
              var instantUrl = timeSlot.instantUrl;
             ; buf.push('<li class="', escape((141,  timeslotParentClasses.join(' ') )), '"> <a class="', escape((141,  timeslotClasses.join(' ') )), '" ');141; if (timeSlot.LinkString) { ; buf.push(' data-rid="', escape((141,  timeslots.Id )), '" data-name="', escape((141,  timeslots.Name )), '" data-datetime="', escape((141,  timeSlot.LinkString )), '" data-covers="', escape((141,  timeSlotsRequest.Covers )), '" ');141; } ; buf.push(' ');141; if (isFakeTimeslotTestOn && typeof process === 'object') { ; buf.push('>', escape((141,  timeSlot.TimeString )), ' ');141; } else if (timeslotDisabled || (isPremium && !Model.Display.ShowPremiumAccess)) { ; buf.push(' data-offers="', escape((141,  offerIds )), '"> &nbsp; ');141; } else { ; buf.push(' ');141; if (hasTableCategories) { ; buf.push(' data-href="', escape((141,  slotUrl )), '" data-table-categories="', (141,  timeSlot.TableCategories ), '" data-table-categories-tooltip-title="Table Types" ');141; } else { ; buf.push(' href="', escape((141,  slotUrl )), '" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((141, timeslots.Id)), ', \'', escape((141, timeSlot.LinkString.substr(timeSlot.LinkString.indexOf(' ')+1))), '\')" ');141; } ; buf.push(' ');141; if (hasPop || hasOffers) { ; buf.push(' ');141; var points = String.Format(Resources.Shared.Redesign.Strings.PointsText, pointValue) ; buf.push(' ');141; var offer = Resources.Shared.Redesign.Strings ; buf.push(' ');141; var offerPlural = offersCount > 1 ? offer.TimeslotLegend_Offers : offer.TimeslotLegend_Offer ; buf.push(' data-has-pop="', escape((141,  hasPop )), '" data-offers="', escape((141,  offerIds )), '" ');141; } else if (isPremium && Model.Display.ShowPremiumAccess) { ; buf.push(' data-premium-access-price-amount="', escape((141,  timeSlot.Price.Amount )), '"> ');141; } ; buf.push(' ');141; if (instantEligible && instantUrl) { ; buf.push(' data-instant-eligible="true" data-instant-url="', escape((141,  instantUrl )), '" ');141; } ; buf.push('> ', escape((141,  timeSlot.TimeString )), ' ');141; if (hasTableCategories) { ; buf.push('<div class="js-table-categories-tooltip table-categories-tooltip"><div class="table-categories-tooltip-arrow"></div><div class="table-categories-tooltip-container"><h5 class="upcase-style">', escape((141,  Resources.Shared.Search.TableCategories.TooltipTitle )), '</h5> ');141; timeSlot.TableCategories.forEach(function(category) {
                          category = category[0].toUpperCase() + category.slice(1, category.length);
                          ; buf.push('<div>', escape((143,  Resources.Shared.Search.TableCategories.Categories[category] )), '</div> ');143; }) ; buf.push('</div></div> ');143; } ; buf.push(' ');143; } ; buf.push('</a> ');143; if (giftAmount) { ; buf.push('<div class="with-points timeslot-with-redemption"> ', escape((143,  giftAmount.Name )), '</div> ');143; } else if (hasOffers) { ; buf.push('<div class="with-points"><i class="with-offers">', escape((143,  offersCount )), '</i>', escape((143,  " " + offerPlural )), '</div> ');143; } else if (!Model.Request.RestRef &&
                ((hasPop && displayOnlyPopTimes && !timeslots.HasOffers) ||
                (hasPop && offersCount === 1))) { ; buf.push('<div class="with-points" data-points-text=\'', escape((145,  points )), '\'> ', escape((145,  points )), '</div> ');145; } else if (isPremium && Model.Display.ShowPremiumAccess) { ; buf.push('<div class="with-points dtp-button-premium-label">Premium</div> ');145; } ; buf.push('</li> ');145; }) ; buf.push(' ');145; if(!timeslots.TimeSlotsComplete) { ; buf.push('<li class="timeslot-option timeslot-empty"></li><li class="timeslot-option timeslot-empty"></li> ');145; } ; buf.push('</ul></div> ');145; if (hasSliding) { ; buf.push('<div class="arrow-right slide-arrow', (145,  fadeRightArrow ? ' faded-arrow' : '' ), '"></div> ');145; } ; buf.push('</div></div> ');145;} else {; buf.push('<div class="rest-row-times-cont"> <a href="', escape((145,  timeslots.ProfileUri )), '" class="button minimal">', escape((145,  Resources.Shared.Common.Results.NextAvailableButton )), '</a> ');145; if (!String.IsNullOrEmpty(timeslots.UnAvailMsg)) { ; buf.push('<p class="not-available-message"> ', (145,  timeslots.UnAvailMsg ), '</p> ');145; } ; buf.push('</div> ');145; } ; buf.push(' ', (145,  partial('Redesign/Results/_SingleSearchReserveLink', {
  searchViewModel: Model,
  restaurantViewModel: timeslots
}) ), '');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Timeslots'}
,"_TopReview":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var review = locals.review ; buf.push(' ');1; if (typeof moment === 'undefined' && locals.helpers.moment) { moment = locals.helpers.moment; } ; buf.push(' ');1; var reviewAge = review.Age > 14 ? moment(review.Date).format(Resources.Strings.DateAddedDateFormat) : review.Age + ' days ago' ; buf.push('<div class="rest-row-topreview"><div class="rest-row-description--callout"><span class="rest-row-description--icon"></span></div><div class="topreview-container"><p class="topreview-text js-ellipsis"> ', escape((1,  review.Text )), ' <a class="ellipsis-showmore">', escape((1,  Resources.Shared.Redesign.Strings.More )), '</a> <a class="ellipsis-showless">', escape((1,  Resources.Shared.Redesign.Strings.Less )), '</a></p> <span class="rest-row-meta">', escape((1,  review.Nickname || Resources.Strings.ReviewerDefaultName )), ' - ', escape((1,  reviewAge )), '</span></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._TopReview'}
},"Search":{"Map":{"_Map":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var mapHeight = locals.mapHeight ; buf.push('<div id="map-inner" class="map-inner"><div id="results_map" class="map-placeholder" style="', (1, mapHeight), '"></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._Map'}
,"_MapOc":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var results = locals.mapOc.Results ; buf.push(' ');1; var domainCulture = locals.mapOc.DomainCulture ; buf.push(' ');1; var ocData = locals.mapOc.ocData ; buf.push('<div class="react-map-container"><oc-component class="react-map" href="', escape((1,  'https://oc-registry.opentable.com/v2/react-map' +
            '?centerPoint=' + encodeURIComponent(btoa(JSON.stringify({lat: results.Lat, lng: results.Long }))) +
            '&zoomLevel=' + encodeURIComponent(results.Zoom) +
            '&domain=' + encodeURIComponent(domainCulture.domain) +
            '&lang=' + encodeURIComponent(domainCulture.culture) +
            '&anonymousId=' + encodeURIComponent(ocData.anonymousId) +
            '&gpid=' + encodeURIComponent(ocData.gpid) )), '" data-name="ot-react-maps" data-rendered="false"></oc-component></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._MapOc'}
,"_Navigation":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('<div><a class="prev"><< ', escape((1,  (Resources.Shared.Search.Map.Navigation_Previous) )), ' </a> <a class="next">', escape((1,  (Resources.Shared.Search.Map.Navigation_Next) )), ' >></a></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._Navigation'}
,"_PinHover":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var pinHover = locals.pinHover ; buf.push('<div class="map-popup" data-index="', (1,  pinHover.Index ), '"><div class="rest-row with-image"><div class="rest-row-info"><div class="rest-row-image"><a href="', escape((1,  pinHover.ProfileUrl )), '" target="_blank" style="background-image: url(\'//resizer.otstatic.com/v2/profiles/small/', escape((1,  pinHover.Id )), '.jpg\')"></a></div><div class="rest-row-name"> <a href="', escape((1,  pinHover.ProfileUrl )), '">', (1,  pinHover.Name ), '</a></div><div class="rest-row-review"> ', (1,  pinHover.ReviewHtml ), '</div><div class="rest-row-pricing"> ', (1,  pinHover.PricingHtml ), '</div><div class="rest-row-meta"> ', (1,  pinHover.MetaDataHtml ), '</div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._PinHover'}
,"_ResultsList":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsList = locals.resultsList ; buf.push(' ');1; var experiments = resultsList.Experiments || {} ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div id="map_results_list" class="results-list content-section"><ul class="content-section-list infinite-results-list"> ');1; resultsList.Results.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (1,  partial('Redesign/Results/_Result', {
          Experiments: experiments,
          Request: resultsList.Request,
          restaurant: restaurant,
          resultViewModel: resultsList,
          onlyPopTimes: false,
          showImages: true,
          restaurantIndex: restaurantIndex,
          showPop: resultsList.Display.ShowPop,
        })
      ), ' ');11; }) ; buf.push('</ul></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._ResultsList'}
,"_ResultsMap":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsMap = locals.resultsMap ; buf.push(' ');1; var mapHeight = locals.desiredHeight ? 'height: ' + locals.desiredHeight + 'px;' : '' ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="page-main cf" style="display: ', escape((1,  resultsMap.Request.ShowMap ? 'block' : '' )), '"><div id="map" class="map-container" style="', (1, mapHeight), '"></div><div id="search" class="search-container to-map-view" style="', (1, mapHeight), '"><div class="max-width-wrapper"><div class="page-main-content"><div class="row"><div class="column no-padding"><div class="content-section-header with-border"> ', (1,  partial('Redesign/Results/_ResultsTitle', {
                resultsTitle: resultsMap
              }) ), '</div><div class="map-results-scroll-container"><div class="with-padding"> ');3; if (resultsMap.Results.Total > 0) { ; buf.push(' ');3; if (resultsMap.Promo != null) { ; buf.push('<div id="single-search-modal-placeholder" class="modal"></div> ');3; } ; buf.push(' ', (3,  partial('_ResultsList', {resultsList: resultsMap}) ), ' ');3; if (resultsMap.Display.ShowPagination) { ; buf.push(' ', (3,  partial('Redesign/Results/_Pagination', {
                      pagination: resultsMap.Display,
                      showPageNumbers: true
                    }) ), ' ');6; } ; buf.push(' ', (6,  partial('Redesign/Results/_AvailabilityLink', {
                  availabilityLink: resultsMap
                  }) ), ' ');8; } else { ; buf.push(' ', (8,  partial('Redesign/Results/_NoResults', {
                    noResults: resultsMap
                  }) ), ' ');10; } ; buf.push('</div> ', (10,  partial('Common/_MapFooter', {Model: resultsMap}) ), '</div></div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._ResultsMap'}
},"_Search":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push('<div class="page-header cf"><div class="max-width-wrapper"><div class="page-header-content"><div class="row"><div class="column"> ', (1,  Html.RenderAction("DateTimePartySize", "Srs") ), '</div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search._Search'}
,"_SearchImage":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push('<div class="image-container ', escape((1,  !String.IsNullOrEmpty(Model.Display.SearchImageClass) ? Model.Display.SearchImageClass : '' )), '" ');1; if (!String.IsNullOrEmpty(Model.Display.SearchImageUrl)) { ; buf.push(' style="background-image: url(\'', escape((1,  Model.Display.SearchImageUrl )), '\'), url(\'', escape((1,  Model.Display.FallbackImageUrl )), '\');" ');1; } ; buf.push('><div class="max-width-wrapper"><div id="overlay_text" class="overlay-text"><div class="page-header-content"><div class="row"><div class="column"> ');1; if (!String.IsNullOrEmpty(Model.Display.EmblemImageUrl)) { ; buf.push(' <img id="emblem" data-src="', escape((1,  (Model.Display.EmblemImageUrl) )), '" class="hide"></img> ');1; } ; buf.push(' ');1; if (!String.IsNullOrEmpty(Model.Display.SearchSmallHeading)) { ; buf.push('<h2 id="smallHeading" class="needs-emblem-offset"> ', escape((1,  (Model.Display.SearchSmallHeading) )), '</h2> ');1; } ; buf.push(' ');1; if (!String.IsNullOrEmpty(Model.Display.SearchBigHeading)) { ; buf.push('<h1 class="needs-emblem-offset"> ', escape((1,  (Model.Display.SearchBigHeading) )), '</h1> ');1; } ; buf.push('</div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search._SearchImage'}
},"_DataLayer":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var marketingDataLayer = locals.marketingDataLayer ; buf.push(' ');1; if (marketingDataLayer) {; buf.push('<script id=\'marketing-data-layer-scripts\'>\n    window.OT = window.OT || {};\n    window.OT.MarketingDataLayer = ', (3,  JSON.stringify(marketingDataLayer) ), ';\n  </script> ');4; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign._DataLayer'}
,"_IeCompat":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('<!-- build:js /s/static/js/generated/ie_compat.js   -->\n<script src="/assets/js/lib/ie/_html5shiv.js"></script><script src="/assets/js/lib/ie/_json2.js"></script><script src="/assets/js/lib/ie/_indexOf.js"></script>\n<!-- endbuild   -->\n');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign._IeCompat'}
,"_Js":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('<!-- build:js /s/static/js/generated/bundle_common_redesign.js   -->\n<!-- Libraries   -->\n<script src="/assets/js/lib/fastclick.js">  </script>\n<script src="/assets/js/lib/jquery.scrollTo.min.js">  </script>\n<!-- Libraries   -->\n<!-- OT Common   -->\n<!-- Diff compared to SRS, can we use the ones from SRS?   -->\n<script src="/assets/js/src/Redesign/Common/Extensions.js">  </script>\n<script src="/assets/js/src/Redesign/Common/Accordion.js">  </script>\n<script src="/assets/js/src/Redesign/Common/TestObject.js">  </script>\n<!-- OT Common   -->\n<!-- Libraries   -->\n<script src="/assets/js/lib/backbone.js"></script>\n<script src="/assets/js/lib/Timer.js"></script>\n<script src="/assets/js/lib/jquery.dotdotdot.min.js"></script>\n<!-- Libraries   -->\n<!-- endbuild   -->\n<!-- START: Sentry Error Logging -->\n');19; if (locals.Model.Environment !== 'dev') { ; buf.push('\n<script src="https://cdn.ravenjs.com/3.12.1/raven.min.js" crossorigin="anonymous"></script>\n<script>Raven.config(\'https://d1cc561f385c431e84cb71c1ca3ff674@sentry.io/148112\').install();</script>\n');22; } ; buf.push('\n<!-- END: Sentry Error Logging -->\n');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign._Js'}
,"_JsImports":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Model = locals.Model ; buf.push('\n');2; var experiment = Model.Experiments ; buf.push('\n');3; var Request = Model.Request ; buf.push('\n<!-- build:js /s/static/js/generated/bundle_redesign.js -->\n<script src="/assets/js/src/Redesign/Views/Filters/DropDown.js"></script>\n<script src="/assets/js/src/Redesign/Common/Lionbars.js"></script>\n<!-- OT Search Helpers   -->\n<script src="/assets/js/src/Search/Helpers/BuildSearchParameters.js"></script>\n<script src="/assets/js/src/Search/Helpers/QueryString.js"></script>\n<script src="/assets/js/src/Search/Helpers/ConvertDateTimeToTimestamp.js"></script>\n<script src="/assets/js/src/Search/Helpers/ConvertIsoDateTimeToTimestamp.js"></script>\n<script src="/assets/js/src/Search/Helpers/ConvertDateToSearchDate.js"></script>\n<script src="/assets/js/src/Search/Helpers/ConvertTimeTo24Hour.js"></script>\n<script src="/assets/js/src/Search/Helpers/DateUtilities.js"></script>\n<script src="/assets/js/src/Search/Helpers/GetFormattedDate.js"></script>\n<script src="/assets/js/src/Search/Helpers/GetFormattedTime.js"></script>\n<script src="/assets/js/src/Search/Helpers/GetIdsFromCheckedItems.js"></script>\n<script src="/assets/js/src/Search/Helpers/IsFutureDateTime.js"></script>\n<script src="/assets/js/src/Search/Helpers/IsMapShowing.js"></script>\n<script src="/assets/js/src/Search/Helpers/RenderTemplate.js"></script>\n<script src="/assets/js/src/Search/Helpers/RoundTimeTo.js"></script>\n<!-- OT Search Helpers   -->\n<!-- OT Search Requests   -->\n<script src="/assets/js/src/Search/Requests/BuildUrl.js"></script>\n<script src="/assets/js/src/Search/Requests/Results.js"></script>\n<!-- OT Search Requests   -->\n<!-- Common Views   -->\n<script src="/assets/js/src/Common/BaseView.js"></script>\n<script src="/assets/js/src/Common/FilterGroupBaseView.js"></script>\n<script src="/assets/js/src/Common/Views/Results/ResultsContainer.js"></script>\n<script src="/assets/js/src/Common/Scroll.js"></script>\n<script src="/assets/js/src/Redesign/Common/ModalBaseView.js"></script>\n<script src="/assets/js/src/Redesign/Views/Modals/Restaurant.js"></script>\n<script src="/assets/js/src/Redesign/Views/Modals/Tooltip.js"></script>\n<!-- Common Views   -->\n<!-- OT Common Helpers   -->\n<script src="/assets/js/src/Redesign/Common/Helpers/GetDeviceInfo.js"></script>\n<script src="/assets/js/src/Redesign/Common/Helpers/GetPageSize.js"></script> \n<script src="/assets/js/src/Redesign/Common/Helpers/Viewport.js"></script>\n<script src="/assets/js/src/Redesign/Common/Helpers/BuildRequestHeaders.js"></script>\n<!-- OT Common Helpers   -->\n<!-- OT Common   -->\n<script src="/assets/js/src/Redesign/Common/Common.js"></script>\n<script src="/assets/js/src/Redesign/Common/LazyLoadImages.js"></script>\n<script src="/assets/js/src/Redesign/Common/App.js"></script>\n<script src="/assets/js/src/Redesign/Common/LoadBannerEmblem.js"></script>\n<script src="/assets/js/src/Redesign/Common/SendLogRequest.js"></script>\n<script src="/assets/js/src/Redesign/Common/Helpers/GetRequestId.js"></script>\n<!-- OT Common   -->\n<!-- Search View   -->\n<script src="/assets/js/src/Search/Views/SearchControl.js"></script>\n<script src="/assets/js/src/Redesign/Views/SearchAnimation.js"></script>\n<script src="/assets/js/src/Redesign/Views/SearchControl.js"></script>\n<script src="/assets/js/src/Redesign/Views/Modals/SingleSearchModal.js"></script>\n<!-- Search View   -->\n<!-- Best Restaurants Results   -->\n<script src="/assets/js/src/Redesign/Views/Results/ResultsContainer.js"></script>\n<script src="/assets/js/src/Redesign/Views/Results/Results.js"></script>\n<script src="/assets/js/src/Redesign/Views/Results/Pagination.js"></script>\n<!-- Best Restaurants Results   -->\n<!-- Best Restaurants Filters   -->\n<script src="/assets/js/src/Redesign/Views/Filters/Sort.js"></script>\n<!-- Best Restaurants Filters   -->\n<!-- Best Restaurants Mobile Refine Filters   -->\n<script src="/assets/js/src/Redesign/Views/RefineFiltersLink.js"></script>\n<script src="/assets/js/src/Redesign/Views/Modals/RefineFiltersModal.js"></script>\n<!-- Best Restaurants Mobile Refine Filters   -->\n<!-- Map   -->\n<script src="/assets/js/src/Redesign/Views/SearchTabs.js"></script>\n<script src="/assets/js/src/Redesign/Views/Results/PopTable.js"></script>\n<script src="/assets/js/src/Redesign/Views/Results/MapResults.js"></script>\n<script src="/assets/js/src/Redesign/Views/Results/Map/ResultsList.js"></script>\n<script src="/assets/js/src/Redesign/Views/Results/Map/ResultsTitle.js"></script>\n<script src="/assets/js/src/Redesign/Views/Results/Map/OcReactMap.js"></script>\n<!-- Map   -->\n<!-- OT Search   -->\n<script src="/assets/js/src/Search/Config.js"></script>\n<script src="/assets/js/src/Search/Data.js"></script>\n<script src="/assets/js/src/Search/Params.js"></script>\n<script src="/assets/js/src/Search/History.js"></script>\n<script src="/assets/js/src/Search/SendLogRequest.js"></script>\n<script src="/assets/js/src/Redesign/App.js"></script>\n<script src="/assets/js/src/Autocomplete.js"></script>\n<script src="/assets/js/src/BestAnalytics.js"></script>\n<script src="/assets/js/src/ExpandableFilters.js"></script>\n<script src="/assets/js/src/TableCategories.js"></script>\n<script src="/assets/js/src/bookedXtimes.js"></script>\n<!-- endbuild -->\n\n<script src="/s/static/js/generated/commonjs-bundle.js"></script>\n\n');92; if (process.env.HARDCODE_AUTOCOMPLETE) { ; buf.push('\n  <script src="http://localhost:9966/one-box-search.js"></script>\n');94; } else { ; buf.push('\n  <script src="//media.otstatic.com/search-autocomplete-client/js/one-box-search-12.13.0.min.js"></script>\n');96; } ; buf.push('\n\n');98; if (!Model.Results.RestaurantIds.length) { ; buf.push('\n  <script src="/s/static/js/NoResults.js"></script>\n');100; } ; buf.push('\n\n<!-- Experiments -->\n\n');104; if (Model.Experiments.sv1852) { ; buf.push('\n  <script src="/s/static/js/Experiments/SV-1852.js"></script>\n');106; } ; buf.push('\n\n<!-- Premium Access   -->\n');109; if (experiment.pretzel939) { ; buf.push('\n  <script src="/s/static/js/Experiments/PremiumAccessCallout.js"></script>\n  <script src="/s/static/js/Experiments/PremiumAccessBookModal.js"></script>\n');112; } ; buf.push('\n\n<script>\n  OT.Common.init();\n  OT.Redesign.init();\n  OT.Autocomplete.init();\n  OT.BestAnalytics.logRequest();\n\n  ');120; if (experiment.pretzel939) { ; buf.push('\n    OT.Search.views.premiumAccessCalloutModal = new OT.Redesign.Views.Modals.PremiumAccessCallout();\n  ');122; } ; buf.push('\n</script>\n');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign._JsImports'}
,"_Resources":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push('<script>\n  window.Resources={\n    Strings: ', (3,  (Html.RenderResourceToJson(Resources.Strings)) ), ',\n    Home: {\n      Index: ', (5,  (Html.RenderResourceToJson(Resources.Home.Index)) ), '\n    },\n    Shared: {\n      Common: {\n        BreadCrumbs: ', (9,  (Html.RenderResourceToJson(Resources.Shared.Common.BreadCrumbs)) ), ',\n        Filters: ', (10,  (Html.RenderResourceToJson(Resources.Shared.Common.Filters)) ), ',\n        LocationBar: ', (11,  (Html.RenderResourceToJson(Resources.Shared.Common.LocationBar)) ), ',\n        Modals: ', (12,  (Html.RenderResourceToJson(Resources.Shared.Common.Modals)) ), ',\n        Results: ', (13,  (Html.RenderResourceToJson(Resources.Shared.Common.Results)) ), ',\n        Strings: ', (14,  (Html.RenderResourceToJson(Resources.Shared.Common.Strings)) ), '\n      },\n      Search: {\n        FreeTextSearch: ', (17,  (Html.RenderResourceToJson(Resources.Shared.Search.FreeTextSearch)) ), ',\n        Map: ', (18,  (Html.RenderResourceToJson(Resources.Shared.Search.Map)) ), ',\n        Results: ', (19,  (Html.RenderResourceToJson(Resources.Shared.Search.Results)) ), ',\n        Strings: ', (20,  (Html.RenderResourceToJson(Resources.Shared.Search.Strings)) ), ',\n        TableCategories: ', (21,  (Html.RenderResourceToJson(Resources.Shared.Search.TableCategories)) ), ',\n        Tabs: ', (22,  (Html.RenderResourceToJson(Resources.Shared.Search.Tabs)) ), '\n      },\n      Redesign: {\n        Filters: ', (25,  (Html.RenderResourceToJson(Resources.Shared.Redesign.Filters)) ), ',\n        Strings: ', (26,  (Html.RenderResourceToJson(Resources.Shared.Redesign.Strings)) ), ',\n        Results: ', (27,  (Html.RenderResourceToJson(Resources.Shared.Redesign.Results)) ), ',\n        NoResults: ', (28,  (Html.RenderResourceToJson(Resources.Shared.Redesign.NoResults)) ), ',\n        PremiumAccess: ', (29,  (Html.RenderResourceToJson(Resources.Shared.Redesign.PremiumAccess)) ), '\n      },\n      PopRestaurantList: {\n        Strings: ', (32,  (Html.RenderResourceToJson(Resources.Shared.PopRestaurantList.Strings)) ), '\n      },\n      MyLists: {\n        Strings: ', (35,  (Html.RenderResourceToJson(Resources.Shared.MyLists.Strings)) ), '\n      }\n    }\n  };\n</script>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign._Resources'}
,"_Search":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var search = locals.search ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="page-header"><div class="max-width-wrapper"><div class="page-header-content"><div class="row"><div class="column"><div id="dtp-picker" action="/search" class="with-search dtp-picker"><div class="dtp-picker-selector"><a class="dtp-picker-selector-link js-toggle-menu"><div id="dtp-label-party" data-bind="text: _vm.dtpPicker.partySize_label" class="dtp-picker-label"> 2 people</div> <select id="covers" data-bind="value: _vm.dtpPicker.partySize, valueUpdate: _vm.dtpPicker.partySize" class="dtp-picker-select" aria-label="select party size"> ');1; search.Display.CoverOptions.forEach(function(option, optionIndex) { ; buf.push('<option value="', escape((1,  (option.Value) )), '"', escape((1,  option.IsSelected ? ' selected' : '' )), '> ', escape((1,  (option.Text) )), '</option> ');1; }) ; buf.push('</select></a></div><div class="dtp-picker-selector"><a class="dtp-picker-selector-link"><div id="dtp-label-date" data-bind="text: _vm.dtpPicker.date_label" class="dtp-picker-label"> Today</div> <select id="date" name="date" data-bind="value: _vm.dtpPicker.date, valueUpdate: _vm.dtpPicker.date" class="dtp-select" aria-label="select date"><option value="0"> Today</option></select></a></div><div class="dtp-picker-selector"><a class="dtp-picker-selector-link js-toggle-menu"><div id="dtp-label-time" class="dtp-picker-label"> 8:00 PM</div> <select id="time" name="time" data-bind="value: _vm.dtpPicker.time, valueUpdate: _vm.dtpPicker.time" class="dtp-picker-select" aria-label="select time"> ');1; search.Display.TimeOptions.forEach(function(option, optionIndex) { ; buf.push('<option value="', escape((1,  (option.Value) )), '"', escape((1,  option.IsSelected ? ' selected' : '' )), '> ', escape((1,  (option.Text) )), '</option> ');1; }) ; buf.push('</select></a></div> <button id="findATable" class="button dtp-picker-button"> ', escape((1,  (Resources.Shared.Common.Strings.Button_FindATable) )), '</button></div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign._Search'}
}},"Home":{"RedesignIndex":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var experiments = Model.Experiments.enums ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var hasMetaDataUrls = (Model.Display.MetaDataUrls != null) ; buf.push(' ');1; var filterClass = "filters-bar"; ; buf.push(' ');1; var isMyListsView = !!(Model.MyListsOptions && Model.MyListsOptions.Name); ; buf.push(' ');1; var hasNoRestaurantsInMyList = Model.Request.HasNoRestaurantsInMyList ; buf.push(' ');1; var moment = locals.helpers.moment ; buf.push(' ');1; var User = locals.User ; buf.push(' ');1;
  var OTSearchData = JSON.stringify({
    DomainInfo: Model.DomainInfo,
    DomainCulture: Model.DomainCulture,
    Environment: Model.Environment,
    NoResultsAreaList: locals.NoResultsAreaList,
    MyListOptions: Model.MyListsOptions,
    Experiments: Model.Experiments,
    Request: Model.Request,
    Display: Model.Display,
    Offers: Model.Offers,
    Filters: Model.Filters,
    IsMyListsView: isMyListsView,
    Results: {
      CampaignIds: Model.Results.CampaignIds,
      QueryCenter: Model.Results.QueryCenter,
      RestaurantIds: Model.Results.RestaurantIds,
      Total: Model.Results.Total,
      TotalAvailable: Model.Results.TotalAvailable,
      TotalUnavailable: Model.Results.TotalUnavailable,
      TotalPop: Model.Results.TotalPop,
      Lat: parseFloat(Model.Results.Lat),
      Long: parseFloat(Model.Results.Long),
      Zoom: Model.Results.Zoom,
    },
    GeoJson: Model.GeoJson
  }).replace(/[\u007f-\uffff]/g, function(c) { return '\\u'+('0000'+c.charCodeAt(0).toString(16)).slice(-4); });
; buf.push('<script>\n  if (/PhantomJS/.test(window.navigator.userAgent)) {\n    window.__TestGaCalls = [];\n    window.MapTrackGA = function(dataPoint) {\n      window.ga = function(_) {\n        window.__TestGaCalls.push(arguments);\n      }\n      var data = {};\n      data[dataPoint] = \'1\';\n      ga(\'gtm1.send\', \'event\', \'map_event\', \'map_event\', data);\n    }\n  }\n  else {\n    window.MapTrackGA = function(dataPoint) {\n      if (typeof ga === \'function\') {\n        var data = {};\n        data[dataPoint] = \'1\';\n        ga(\'gtm1.send\', \'event\', \'map_event\', \'map_event\', data);\n      }\n    }\n  }\n</script> ');49; var showAdvert =
  !isMyListsView &&
    !(Model.Request.PageType == PageType.AFFILIATE_RESTAURANT_LIST &&
      Model.Request.RestRef);
; buf.push(' ');53; var noResultsView = isMyListsView && hasNoRestaurantsInMyList ?
    'Redesign/Results/_MyListsNoResults' :
    'Redesign/Results/_NoResults'; buf.push(' ');55;
  var bodyCssClasses = [];
  bodyCssClasses.push(Model.Display.CurrentView);

  var noResultsClass = Model.Results.TotalAvailable ? 'has-results' : 'no-results';
  bodyCssClasses.push(noResultsClass);

  // TODO: Set all these body classes using viewModel.Experiments.bodyClasses
  if (Model.Request.IsAvailabilityRequest) {
    bodyCssClasses.push("availability-search");
  }
  if (Model.Display.IsInitialLoad) {
    bodyCssClasses.push('initial-load');
  }

  if (Model.Request.RestRef) {
    bodyCssClasses.push('rest-ref');
  }

  if (isMyListsView) {
    bodyCssClasses.push('mylists-view');
  }
  if (Model.Results.AddonsRestaurant && Model.Results.AddonsRestaurant.Total) {
    bodyCssClasses.push('hidden-featured-pop');
  }

  if (Model.Request.PageType) {
    bodyCssClasses.push('not-multi-search');
  }

  if (Model.Request.Term) {
    bodyCssClasses.push('freetext-search');
  }

  if (Model.DinersChoice.Ratings) {
    bodyCssClasses.push('diners-choice');
    bodyCssClasses.push('has-results');
  }

  if (Model.Display.ShowPremiumAccess) {
    bodyCssClasses.push('premium-access');
  }

  if (Model.UserAgent.indexOf('Android') !== -1) {
    setPlatform('android');
    setPlatform('mobile');
  } else if (Model.UserAgent.indexOf('Pixel') !== -1) {
    setPlatform('android');
    setPlatform('mobile');
    setDevice('tablet');
  } else if (Model.UserAgent.indexOf('iPad') !== -1) {
    setPlatform('ios');
    setPlatform('mobile');
    setDevice('tablet');
  } else if (Model.UserAgent.indexOf('iPhone') !== -1) {
    setPlatform('ios');
    setPlatform('mobile');
    setDevice('phone');
  } else if (Model.UserAgent.indexOf('touch') !== -1) {
    setPlatform('mobile');
    setDevice('phone');
  } else if (Model.UserAgent.indexOf('tablet') !== -1) {
    setPlatform('mobile');
    setDevice('tablet');
  } else {
    // Probably desktop, could be mobile
    setPlatform('unknown');
    setDevice('unknown');
  }

  function setPlatform(type) { //as in is this mobile or (probably) desktop
    if (type === 'mobile') {
      bodyCssClasses.push('hide-lhn'); // Mobile devices should show LHN
    }
    bodyCssClasses.push('platform-' + type);
  }

  function setDevice(type) { //as in is this an android, laptop, tablet, etc.
    bodyCssClasses.push('device-' + type);
  }

  bodyCssClasses.push('page-type-' + Model.Request.PageType);

  bodyCssClasses = bodyCssClasses.concat(Model.Experiments.bodyClasses);
; buf.push(' ');139; block('pageTitle').append(
  '<title>' + Model.Display.PageMetaData.Title + '</title>'
 ) ; buf.push(' ');141; block('metaData').append(
( !String.IsNullOrEmpty(Model.Display.OpenGraphImageUrl) ? '<meta  property="og:image" content="'
 + (Model.Display.OpenGraphImageUrl)
 + '" >' + ' '
 + '</meta>' : '')
 + ' '
 + ( !String.IsNullOrWhiteSpace(Model.Display.PageMetaData.Description) ? '<meta  name="description" content="'
 + (Model.Display.PageMetaData.Description)
 + '" >' + ' '
 + '</meta>' : '')
 + ' '
 + ( !String.IsNullOrWhiteSpace(Model.Display.PageMetaData.Keywords) ? '<meta  name="keywords" content="'
 + (Model.Display.PageMetaData.Keywords)
 + '" >' + ' '
 + '</meta>' : '')
 + ' '
 + ( !String.IsNullOrWhiteSpace(Model.Display.PageMetaData.Robots) ? '<meta  name="robots" content="'
 + (Model.Display.PageMetaData.Robots)
 + '" >' + ' '
 + '</meta>' : '')
 + ( (hasMetaDataUrls && !String.IsNullOrWhiteSpace(Model.Display.MetaDataUrls.Canonical)) ? '<link  rel="canonical" href="'
 + (Model.Display.MetaDataUrls.Canonical)
 + '" >' + ' '
 + '</link>' : '')
 + ' '
 + ( (hasMetaDataUrls && !String.IsNullOrWhiteSpace(Model.Display.MetaDataUrls.PagePrevious)) ? '<link  rel="prev" href="'
 + (Model.Display.MetaDataUrls.PagePrevious)
 + '" >' + ' '
 + '</link>' : '')
 + ' '
 + ( (hasMetaDataUrls && !String.IsNullOrWhiteSpace(Model.Display.MetaDataUrls.PageNext)) ? '<link  rel="next" href="'
 + (Model.Display.MetaDataUrls.PageNext)
 + '" >' + ' '
 + '</link>' : '')
 + ' '
 + ( (hasMetaDataUrls && (Model.Display.MetaDataUrls.Hreflang != null)) ?       '      '
 + Model.Display.MetaDataUrls.Hreflang.map(function(hreflang) { return         '        '
 + '<link rel="alternate" hreflang="'
 + (hreflang.Culture)
 + '" href="'
 + (hreflang.Url)
 + '"/>'
 + ' '
 }).join('\n')
 + ' '
 : '')
 ) ; buf.push(' ');187; block('cssComponent').append(
  Html.RenderAction("Css", "Srs", { domainCulture:Model.DomainCulture })
) ; buf.push(' ');189; block('cssImports').append(
   '<link rel="stylesheet" href="/s/static/css/bundle_redesign_search.css"/>'
 + '<!--[if lte IE 8]><link rel="stylesheet" href="/s/static/css/bundle_redesign_search_ie8.css" /> <![endif]  -->'
) ; buf.push(' ');192; block('favicon').append(
  Html.RenderAction("Favicon", "Srs", { domainCulture:Model.DomainCulture })
) ; buf.push(' ');194; block('otDataLayer').append(Html.RenderOtDataLayerCode()) ; buf.push(' ');194; block('jsHead').append(
 Html.RenderAction("JsHead", "Srs", { domainCulture:Model.DomainCulture })
) ; buf.push(' ');196; block('jsComponent').append(
 Html.RenderAction("Js", "Srs", { domainCulture:Model.DomainCulture, jqueryOnBody:false })
) ; buf.push(' ');198; block('bodyClass').append(bodyCssClasses.join(' ')) ; buf.push(' ', (198,  Html.RenderAction("Header", "Srs", {
  pageType: Model.Display.SrsPageType,
  domainCulture: Model.DomainCulture,
  metro: Model.Display.Metro
}) ), ' ', (202,  Html.RenderAction('GiftRedemptionBanner', 'Srs') ), ' ', (202,  Html.RenderAction('InstantBooking', 'Srs') ), '<div class="', escape((202,  ( Model.Display.ShowSearchImage ? 'search-image' : '') )), '"> ');202; if (Model.Display.ShowSearchImage) { ; buf.push(' ', (202,  partial('Redesign/Search/_SearchImage', { } ) ), ' ');202; } ; buf.push('<div id="search_control" class="labels cf"> ', (202,  partial('Redesign/Search/_Search', { 'search': Model } ) ), '</div></div> ', (202,  partial('Redesign/Modals/_TableCategoriesModal', {
  Model: Model,
  Resources: Resources
}) ), ' <input type="hidden" name="_csrf" id="_csrf" value="', (205,  locals.Csrf ), '"><div id="no-re-render-container" class="overall-search-container"> ');205; if (Model.Display.ShowFilters) { ; buf.push(' ');205; if (Model.Display.ShowLocationsFilter === false
        && Model.Display.ShowCuisineFilter === false
        && Model.Display.ShowPrices === false){
         filterClass = "filters-bar sort-only-padding";
        }
    ; buf.push('<div id="filters-bar" class="', escape((210,  filterClass )), ' show-filter-content"><div class="max-width-wrapper"><div class="row"><div class="column"> ', (210,  partial('Redesign/Filters/_Filters', {
              filters: Model
            }) ), '</div></div></div></div> ');212; } ; buf.push('<div class="stack-selected-filters"> ');212; if (Model.Display.ShowFilters) { ; buf.push('<div class="toggle-filter-bar"><div id="filter-toggle"><div class="filter-toggle-icon"></div> <span class="show-filter-text">', (212,  Resources.Shared.Common.Filters.ShowFilters ), '</span> <span class="hide-filter-text">', (212,  Resources.Shared.Common.Filters.HideFilters ), '</span></div></div><div class="selected-filters js-selected-filters full-width-wrapper"><div class="row"><div id="js-selected-filters-column" class="column"></div></div></div> ');212; } ; buf.push('<div id="search_results_container" class="search-results-container page-main-content max-width-wrapper"><div class="close-filters"></div> ', (212,  partial('Common/_Spinner', {} ) ), ' ', (212,  partial('Redesign/Modals/_SingleSearchModal', {
          singleSearchModalModel: Model
      }) ), '<div id="search_results" class="results-set results-table search-results" data-name="ResultsTable"> ');214; if (!Model.Request.ShowMap) { ; buf.push(' ');214; if (Model.Results.Total > 0) { ; buf.push(' ', (214,  partial('Redesign/Results/_ResultsTable', {
              resultsTable: Model,
              helpers: locals.helpers,
              PageType: PageType,
              AdvertType: AdvertType,
              Html: Html,
              isMyListsView: isMyListsView,
              showAdvert: showAdvert
            }) ), ' ');222; } else { ; buf.push(' ', (222,  partial(noResultsView, {
              noResults: Model,
              clearLastFilter: false
            }) ), ' ');225; } ; buf.push(' ');225; } ; buf.push('</div><div id="search_results_map" class="results-set results-map search-results" data-name="ResultsMap"> ');225; if (Model.Request.ShowMap) { ; buf.push(' ', (225,  partial('Redesign/Search/Map/_ResultsMap', {
            resultsMap: Model,
            count: 0,
            clearLastFilter: false
          }) ), ' ');229; } ; buf.push('</div> ');229; if (Model.Request.PageType == PageType.DINERS_CHOICE_LIST) { ; buf.push(' ', (229,  partial('Redesign/DinersChoiceList/_LinkSection', {
          linkSection: Model
        }) ), ' ');231; } ; buf.push('<div id="row-service-results"></div></div></div><div id="right-sidebar" class="right-sidebar"> ');231; if (showAdvert) { ; buf.push(' ', (231,  Html.RenderAction("Advert", "Srs", {
        advertType: AdvertType.BigBox,
        pageType: Model.Display.SrsPageType,
        domainCulture: Model.DomainCulture,
        metro: Model.Display.Metro
      }) ), ' ');236;}; buf.push('</div></div> ');236; if (Model.Display.ShowPremiumAccess) { ; buf.push('<div id="premium-access-callout"></div> ');236; block('premiumAccess').append(
  Html.RenderAction("PremiumAccess", "Srs", {})
  ) ; buf.push('<div id="premium-access_book-modal_wrapper"> ', (238,  partial('Redesign/Modals/_PremiumAccessBookModal') ), '</div> ');238; } ; buf.push(' ', (238,  partial('Common/_SeoFooter', {
  seoFooter: Model
}) ), ' ');240; if (showAdvert) { ; buf.push(' ', (240,  Html.RenderAction("Advert", "Srs", {
    advertType: AdvertType.FloatingFooter,
    pageType: Model.Display.SrsPageType,
    domainCulture: Model.DomainCulture,
    metro: Model.Display.Metro
  }) ), ' ');245; } ; buf.push('<script>\n  window.OTSearchData = ', (246,  OTSearchData ), '\n</script> ');247; block('resources').append(partial('Redesign/_Resources', {})) ; buf.push(' ');247; block('tracking').append(Html.RenderTrackingCode(Model.TrackingValues)) ; buf.push(' ');247;
  var todaysDate = new Date();

  var marketingDataLayer = {
    language: Request.DomainCulture.culture,
    page_name: 'search',
    time_search: moment(Request.ParsedDateTime).format('LTS'),
    date_search: moment(Request.ParsedDateTime).format(),
    current_date: todaysDate.toISOString(),
    day_type: todaysDate.getDay() % 6 ? 'weekday' : 'weekend'
  };

  if (Model.Display.GeoLocation.Longitude && Model.Display.GeoLocation.Latitude) {
    marketingDataLayer.searchgeo_longlat = String.Format(
      '{0},{0}',
      Model.Display.GeoLocation.Longitude,
      Model.Display.GeoLocation.Latitude
    );
  }

  if (User.GlobalPersonId) {
    marketingDataLayer.logged_in_status = 'logged_in',
    marketingDataLayer.user_primary_metro_id = User.MetroId,
    marketingDataLayer.user_origin = User.MetroId
  } else {
    marketingDataLayer.logged_in_status = 'logged_out'
    marketingDataLayer.user_primary_metro_id = Request.MetroId,
    marketingDataLayer.user_origin = Request.MetroId
  }
; buf.push(' ');276; block('marketingDataLayer').append(partial('Redesign/_DataLayer', { marketingDataLayer: marketingDataLayer })) ; buf.push(' ', (276,  Html.RenderAction('GiftLeaveConfirmation', 'Srs') ), '');
return buf.join('');
},
   namespace: 'Spark.Home.RedesignIndex'}
},"Interim":{"RedesignIndex":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var model = locals.Model ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<!DOCTYPE html><html><head><meta charset="utf-8"/><meta name="viewport" content="user-scalable=yes"/><meta http-equiv="X-UA-Compatible" content="IE=9; IE=8; IE=7; IE=EDGE"/> ', (1,  Html.RenderAction("Favicon", "Srs", { domainCulture:Model.DomainCulture }) ), '<noscript><meta HTTP-EQUIV="REFRESH" content="0;URL=', escape((1,  (Model.RedirectUri) )), '"/></noscript><!--[if lte IE 9]>" }<meta HTTP-EQUIV="REFRESH" content="0;URL=', escape((1,  Model.RedirectUri )), '"> <![endif]    --><script type="text/javascript" src="//fonts.otstatic.com/dwh4rpg.js"></script><script type="text/javascript">\n      try{Typekit.load();}catch(e){}\n    </script><script type="text/javascript" src="/s/static/js/OptimizelyUtils.js"></script><title>', escape((3,  Resources.Interim.Index.Strings.PageTitle )), '</title> ', (3,  Html.RenderAction("Css", "Srs", { domainCulture:Model.DomainCulture }) ), ' ', (3,  Html.RenderAction("JsHead", "Srs", { domainCulture:Model.DomainCulture }) ), '<link rel="stylesheet" href="/s/static/css/bundle_redesign_search.css"/></head> ');3;
  var bodyCssClasses = ['search', 'interim'];
  bodyCssClasses.push(Html.CurrentTheme(Model.DomainCulture))
  bodyCssClasses.push('domain-' + Model.DomainCulture.Domain.toString().toLowerCase());
; buf.push('<body class="', escape((7,  bodyCssClasses.join(' ') )), '"><div class="interim-loader"><div class="spinner"></div><div class="loader-content"><p>', escape((7,  Resources.Interim.Index.Strings.InterimLoader )), '</p></div></div><script>\n        var ie = (function(){\n            var undef,\n            v = 3,\n            div = document.createElement(\'div\'),\n            all = div.getElementsByTagName(\'i\');\n            while (\n            div.innerHTML = \'<!--[if gt IE \' + (++v) + \']><i></i><![endif]-->\',\n            all[0]\n            );\n            return v > 4 ? v : undef;\n        }());\n        (function() {\n            if (ie <= 9) {\n                return;\n            }\n\n            var model = ', (24,  (Model.ToJson()) ), ';\n            var url = "', (25,  (Model.RedirectUri) ), '";\n\n            if (typeof(OT) === "object" && typeof(OT.ApplyOptimizelyChanges) === "function") {\n                url = OT.ApplyOptimizelyChanges(model);\n            }\n\n            window.onload=function(){ window.location.href = url; };\n        })();\n    </script></body></html>');
return buf.join('');
},
   namespace: 'Spark.Interim.RedesignIndex'}
},"Layouts":{"Redesign":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var body = locals.body ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var pageType = Model.Request.CssClassForPageType ? 'pagetype-' + Model.Request.CssClassForPageType : '' ; buf.push(' ');1; var currentTheme = Html.CurrentTheme(Model.DomainCulture) ; buf.push(' ');1; var domain = Model.DomainCulture.Domain ? 'domain-' + Model.DomainCulture.Domain.toString().toLowerCase() : '' ; buf.push('<!DOCTYPE html><html lang="', escape((1,  (Model.DomainCulture.Language) )), '"><head><meta charset="utf-8"/><meta http-equiv="X-UA-Compatible" content="IE=9; IE=8; IE=7; IE=EDGE"/> ', (1,  block('pageTitle').toString() ), ' ', (1,  block('metaData').toString() ), ' ', (1,  block('favicon').toString() ), '<meta content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" name="viewport"/> ', (1,  block('cssImports').toString() ), ' ', (1,  block('otDataLayer').toString() ), ' ', (1,  block('jsHead').toString() ), '<!--[if IE]>', (1,  partial('Redesign/_IeCompat', {}) ), '<![endif]--></head><body class="search ', escape((1,  currentTheme )), ' ', escape((1,  pageType )), ' ', escape((1,  domain )), ' ', (1,  block('bodyClass').toString() ), '"> ', (1,  Html.AntiForgeryToken() ), '<div class="master-container" id="search-master-container"> ', (1,  body), '</div><div id="tooltip" class="tooltip"></div><div id="results_modal" class="tooltip"></div><div id="filters_modal" class="modal filters-modal"></div> ', (1,  block('data').toString() ), ' ', (1,  block('resources').toString() ), '<script src="/s/static/js/generated/bundle_views_redesign.js"></script> ', (1,  block('marketingDataLayer').toString() ), ' ', (1,  block('jsComponent').toString() ), ' ', (1,  partial('Redesign/_Js', {}) ), ' ', (1,  partial('Redesign/_JsImports', {}) ), ' ', (1,  block('premiumAccess').toString() ), '<script>      ', (1,  block('tracking').toString() ), '\n    </script></body></html>');
return buf.join('');
},
   namespace: 'Spark.Layouts.Redesign'}
},"Srs":{"_Advert":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var model = locals.Model ; buf.push(' ');1; var AdvertType = locals.AdvertType ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="page-ad-section hide-for-small-only hide-for-medium-only"> <a class="page-ad-link">');1; if (Model.Environment !== 'test') { ; buf.push(' ', (1,  Model ), ' ');1; } ; buf.push('</a></div>');
return buf.join('');
},
   namespace: 'Spark.Srs._Advert'}
,"_RenderHtml":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('', (1,  locals.Model ), '');
return buf.join('');
},
   namespace: 'Spark.Srs._RenderHtml'}
}}})();